<template>
  <div class="editPage" ref="editSpu" v-show="editProductModal">
    <Spin v-if="editPageLoaing" fix>数据加载中....</Spin>
    <!-- 头部工具条 -->
    <div class="topBtn">
      <div class="head-tabs">
        <RadioGroup v-model="pageEditTag" type="button">
          <template v-for="(tag, index) in tagList">
            <Radio
              v-if="!tag.powerKey || (tag.powerKey && permission[tag.powerKey])"
              :label="tag.value"
              :key="`tag-${index}`"
            >
              {{ tag.label }}
              <span v-if="tag.value == 'gpsrInfo'" class="gpsr-tips-icon">
                <Icon v-if="$common.isEmpty(pageGpsrInfo)" type="md-close" />
                <Icon v-else type="md-checkmark" />
              </span>
            </Radio>
          </template>
        </RadioGroup>
      </div>
      <div class="top-buttons">
        <div v-show="!isDisabled" style="display: inline-block;">
          <Button type="primary" :loading="waitingOk || spinShow" @click="beforeSave(false)" v-if="isSupplierTalg">暂存</Button>
          <Button type="primary" class="ml10" v-if="!initFinished || skuData.length > 0" :loading="waitingOk || spinShow" @click="beforeSave(true)">{{ isSupplierTalg ? '提交审批' : '保存' }}</Button>
          <Button class="ml10" type="warning" v-if="initFinished && skuData.length === 0" :loading="waitingOk || spinShow" @click="del">删除</Button>
        </div>
        <!-- 编辑图片 -->
        <div v-show="isEditPicture" style="display: inline-block;">
          <Button type="primary" :loading="waitingOk || spinShow" @click="beforeSave(false)">保存</Button>
        </div>
        <Button @click="turnBack" class="ml10">取消</Button>
      </div>
    </div>
    <Form ref="productInfo" class="edit-page-form" :model="productInfo" :label-width="110" label-position="right">
      <!-- 基础资料 -->
      <div class="tag-content-baseInfo tag-comtent-item" v-show="pageEditTag == 'baseInfo'">
        <div v-if="pageTagView['baseInfo']">
          <!-- 基本信息 -->
          <div style="display:flex">
            <div style="flex-direction:column">
              <div class="productsCont formItemLeft">
                <div class="productsTit padding-10">
                  <div id="basic">
                    基本信息
                  </div>
                </div>
                <div class="products-content padding-10">
                  <!-- 商品中文名称 -->
                  <Form-item label="中文名称" prop="cnName"
                    :rules="{ required: true, message: '商品中文名称' + '不能为空', trigger: 'blur' }">
                    <Input :disabled="isDisabled" :maxlength="1000" v-model.trim="productInfo.cnName"
                      placeholder="请输入商品中文名称"></Input>
                  </Form-item>
                  <!-- 商品英文名称 -->
                  <Form-item label="英文名称" prop="enName">
                    <Input :maxlength="1000" :disabled="isDisabled" v-model.trim="productInfo.enName"
                      placeholder="请输入商品英文名称"></Input>
                  </Form-item>
                  <!-- SPU/商品编码 -->
                  <Form-item label="SPU" prop="spu"
                    :rules="[{ required: true, message: 'SPU/商品编码' + '不能为空', trigger: 'blur' }, { validator: validateFormSku, trigger: 'blur' }]">
                    <Input :maxlength="100" disabled v-model.trim="productInfo.spu" placeholder="请输入SPU/商品编码"></Input>
                    <!-- :disabled="isDisabled" -->
                  </Form-item>
                  <!-- 分类 -->
                  <Form-item label="所属分类" prop="productCategoryId" v-if="!isSupplierTalg" :rules="[
                    { required: true, message: '请选择所属分类', trigger: 'change' }
                  ]">
                    <erpTreeSelect v-if="!isLoadInfo" :disabled="isDisabled" v-model="treeSelectCategoryValue"
                      :multiple="false" :normalizer="treeNormalizer" :options="productCategoryTree"
                      :default-expand-level="Infinity" placeholder="请选择所属分类" noResultsText="无匹配数据" @input="getTreeData" />
                  </Form-item>
                  <Form-item label="云卖分类" prop="ymsProductCategoryId" v-if="isSupplierTalg" class="classify_style"
                    :class="{ 'ivu-form-item-error': productInfo.ymsProductCategoryId === null }">
                    <treeSelect ref="productCategoryTree1" :disabled="isDisabled" :treeData="ymsMenuList"
                      @on-change="getYmsTreeData" filterable placeholder="请选择云卖分类" />
                    <div v-show="productInfo.ymsProductCategoryId === null" class="ivu-form-item-error-tip">
                      请选择云卖分类！
                    </div>
                  </Form-item>
                  <!-- 品牌 -->
                  <Form-item label="品牌" prop="productBrandId">
                    <dyt-select v-model.trim="productInfo.productBrandId" :disabled="isDisabled" :transfer="true" filterable
                      placeholder="请选择品牌">
                      <Option v-for="(item, index) in productBrandList" :key="index"
                        :class="{ productBrandRed: item.status === 0, hidden: item.status === 0 && item.productBrandId !== productInfo.productBrandId }"
                        :value="item.productBrandId">{{ item.name }}
                      </Option>
                    </dyt-select>
                  </Form-item>
                  <!-- 商品开发员 -->
                  <Form-item
                    label="开发员"
                    v-if="!isSupplierTalg"
                    prop="productDeveloperUserId"
                    :rules="[
                      { required: true, message: '请选择开发员', trigger: 'change' }
                    ]"
                  >
                    <dyt-select v-model="productInfo.productDeveloperUserId" :disabled="isDisabled">
                      <Option v-for="item in businessRoleTypeList" :value="item.userId" :key="item.userId">{{ item.userName }}</Option>
                    </dyt-select>
                  </Form-item>
                  <Form-item label="编织类型" v-if="isClothingType">
                    <dyt-select v-model="productInfo.braidType" :disabled="isDisabled">
                      <Option v-for="item in braidDataList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </dyt-select>
                  </Form-item>
                  <FormItem label="材质中文描述:" prop="materialCnDesc">
                    <!-- :rules="[
                          { required: true, message:'材质中文描述不能为空', trigger: 'blur' },
                          { required: true, message:'材质中文描述不能为空', trigger: 'change' }
                        ]" -->
                    <Input v-model="productInfo.materialCnDesc" placeholder="请输入" :maxlength="50" clearable
                      :disabled="isDisabled" />
                  </FormItem>
                  <FormItem label="材质英文描述:" prop="materialEnDesc">
                    <!-- :rules="[
                          { required: true, message:'材质英文描述不能为空', trigger: 'blur' },
                          { required: true, message:'材质英文描述不能为空', trigger: 'change' }
                        ]" -->
                    <Input v-model="productInfo.materialEnDesc" placeholder="请输入" :maxlength="50" clearable
                      :disabled="isDisabled" />
                  </FormItem>
                  <FormItem label="用途中文描述:" prop="usageCnDesc">
                    <!-- :rules="[
                          { required: true, message:'用途中文描述不能为空', trigger: 'blur' },
                          { required: true, message:'用途中文描述不能为空', trigger: 'change' }
                        ]"
                      > -->
                    <Input v-model="productInfo.usageCnDesc" placeholder="请输入" :maxlength="50" clearable
                      :disabled="isDisabled" />
                  </FormItem>
                  <FormItem label="用途英文描述:" prop="usageEnDesc">
                    <!-- :rules="[
                          { required: true, message:'用途英文描述不能为空', trigger: 'blur' },
                          { required: true, message:'用途英文描述不能为空', trigger: 'change' }
                        ]"
                      > -->
                    <Input v-model="productInfo.usageEnDesc" placeholder="请输入" :maxlength="50" clearable
                      :disabled="isDisabled" />
                  </FormItem>
                  <Form-item label="发货时效" prop="deliveryInterval" v-if="isSupplierTalg">
                    <dyt-select v-model="productInfo.deliveryInterval" :disabled="isDisabled">
                      <Option v-for="(item, index) in deliveryIntervalList" :value="item.value" :key="index">{{ item.name }}
                      </Option>
                    </dyt-select>
                  </Form-item>
                  <FormItem label="特殊标识:" prop="specialMarkList">
                    <dyt-select v-model="productInfo.specialMarkList" :disabled="isDisabled" :max-tag-count="1" multiple>
                      <Option v-for="item in specialMarkOption" :value="item.value" :key="item.value">{{ item.label
                      }}</Option>
                    </dyt-select>
                  </FormItem>
                </div>
              </div>
            </div>
            <!-- 图片信息 -->
            <productImageInfo
              :imagesInfoData.sync="multiLangImageData"
              :isDisabled="isEditPicture ? false : isDisabled"
              :instructionsPath.sync="productInfo.instructionsPath"
              :pictureTypeList.sync="productInfo.pictureTypeList"
              :spu="productInfo.spu"
              :pictureTypeData="pictureTypeData"
              :filenodeViewTargetUrl="filenodeViewTargetUrl"
              :productInfo="productInfo"
              :editStatus="editStatus" />
          </div>
          <!-- 报关信息 -->
          <div class="sxContent flex-30" v-if="!isSupplierTalg">
            <div class="productsTit padding-10">
              <div id="customs">
                报关信息
              </div>
            </div>
            <div class="products-content padding-10 form-item-flex-wrap">
              <!-- 报关中文名称 -->
              <Form-item label="报关中文名称" prop="cnHsName" :label-width="130"
                :rules="{ required: true, validator: hsNameMaxVerify, msg: '请输入报关中文名称', maxLength: 200, trigger: 'blur' }">
                <Input :disabled="isDisabled" v-model.trim="productInfo.cnHsName" placeholder="请输入报关中文名称" />
              </Form-item>
              <!-- 报关英文名称 -->
              <Form-item label="报关英文名称" prop="enHsName" :label-width="130"
                :rules="{ required: true, validator: enNameMaxVerify, msg: '请输入报关英文名称', maxLength: 200, trigger: 'blur' }">
                <Input :disabled="isDisabled" v-model.trim="productInfo.enHsName" placeholder="请输入报关英文名称" />
              </Form-item>
              <!-- 报关编码 -->
              <Form-item label="报关编码(HS Code)" prop="hsCode" :label-width="150"
                :rules="{ required: true, validator: hsCodeVerify, msg: '请输入报关编码(HS Code)', minLength: 10, maxLength: 10, trigger: 'blur' }">
                <Input :disabled="isDisabled" v-model.trim="productInfo.hsCode" placeholder="请输入报关编码（HS Code）"></Input>
              </Form-item>
            </div>
          </div>
          <!-- 平台类目 -->
          <div class="sxContent">
            <product-platform-category
              ref="productPlatformCategoryRef"
              :productInfo="productInfo"
              :isDisabled="true"
              @change="handlePlatformCategoryChange"
            />
          </div>
          <!-- 商品属性 -->
          <div class="sxContent">
            <product-attribute
              ref="productAttributeRef"
              :productInfo="productInfo"
              :isDisabled="isDisabled"
            />
          </div>
          <!-- 质检标准 -->
          <div class="productsCont normalTop">
            <div class="productsTit padding-10">
              质检标准
            </div>
            <div class="products-content padding-20">
              <div>
                <Form-item label="质检类型" prop="checkType" style="display: inline-block;">
                  <RadioGroup v-model="productInfo.checkType">
                    <Radio label="0" :disabled="isDisabled">免检</Radio>
                    <Radio label="2" :disabled="isDisabled">全检</Radio>
                    <Radio label="1" :disabled="isDisabled">抽检</Radio>
                  </RadioGroup>
                </Form-item>
                <Form-item
                  label="质检比例(%)"
                  prop="checkRate"
                  style="display: inline-block;"
                  :rules="{
                    validator: validateCheckRate,
                    min: 1,
                    max: 99,
                    point: 0,
                    msg: `请输入质检比例`,
                    trigger: 'change'
                  }"
                >
                  <Input :disabled="isDisabled || ![1, '1'].includes(productInfo.checkType)"
                    v-model.trim="productInfo.checkRate" placeholder="请输入质检比例" />
                </Form-item>
                <Form-item
                  label="应检最少数量"
                  prop="minCheckNum"
                  style="display: inline-block;"
                  :rules="{
                    validator: validateMinCheckNum,
                    min: 1,
                    point: 0,
                    msg: `请输入应检最少数量`,
                    trigger: 'change'
                  }"
                >
                  <Input
                    :disabled="isDisabled || [0, '0'].includes(productInfo.checkType)"
                    v-model.trim="productInfo.minCheckNum"
                    placeholder="请输入应检最少数量"
                  />
                </Form-item>
                <Form-item
                  label="新供应商强制全检"
                  prop="newSupplierCheck"
                  style="display: inline-block;"
                >
                  <Checkbox v-model="productInfo.newSupplierCheck" :disabled="isDisabled" />
                </Form-item>
                <Form-item
                  label="常规尺寸重量核验"
                  prop="basicSpecificationVerification"
                  style="display: inline-block;"
                >
                  <Checkbox v-model="productInfo.basicSpecificationVerification" :disabled="isDisabled" />
                </Form-item>
              </div>
              <qualityInspectionStandard
                v-if="!isLoadInfo"
                ref="qualityInspection"
                :product-id="productId"
                :disabled="isDisabled"
                :product-info="productInfo"
                :editProductModal="editProductModal"
                :product-category-list-data="productCategoryListData"
              />
            </div>
          </div>
          <!-- 商品描述 -->
          <div class="productsCont normalTop">
            <div class="productsTit padding-10">
              <div id="productDis">
                商品描述
              </div>
            </div>
            <div class="products-content padding-10 tabs-textmaterial">
              <div class="components-container">
                <Tabs v-model="langActiveTab" @on-click="langTabsSwitch" name="langTabName">
                  <TabPane v-for="(item, index) in languageTab" :label="item.label" :name="item.key"
                    :key="`${index}-${item.key}`" tab="langTabName" />
                </Tabs>
                <!-- <Button class="tabs-btnpos" size="small" @click="openSizeChart">生成尺码图</Button> -->
                <Dropdown transfer @on-click="openSizeChart" class="tabs-btnpos" trigger="click">
                  <Button size="small" type="primary">生成尺码图 <Icon type="ios-arrow-down"></Icon></Button>
                  <DropdownMenu slot="list">
                    <DropdownItem :name="1">通用尺码图</DropdownItem>
                    <DropdownItem :name="2">婴童尺码图</DropdownItem>
                    <DropdownItem :name="3">儿童尺码图</DropdownItem>
                    <DropdownItem :name="4">女鞋尺码图</DropdownItem>
                  </DropdownMenu>
                </Dropdown>

                <Form-item :label-width="90" label="关键词：">
                  <local-tag-input style="width: 100%; display: inline-block" :disabled="isDisabled"
                    :tags="descriptionBOJson[langActiveTab]['keywords']" />
                </Form-item>
                <Tabs v-model="descActiveTab" type="card" @on-click="descTabsSwitch" name="descTabName">
                  <TabPane v-for="(desc, dIndex) in descriptionTab" :label="desc.label" :name="desc.key"
                    :key="`${dIndex}-${desc.key}`" tab="descTabName" />
                </Tabs>
                <div class="editor-container">
                  <UE :disabled="isDisabled" :content.sync="descriptionBOJson[langActiveTab][descActiveTab]"
                    :htmlStatus="false" v-show="initFinished && descActiveTab !== 'textDescription'"
                    id="productInfo.description.edit" :config=config ref="descdomeue" :isVisible.sync="isVisible"
                    @childType="getChildType" />
                  <Input v-show="initFinished && descActiveTab === 'textDescription'" style="width: 100%;" type="textarea"
                    :autosize="{ minRows: 26, maxRows: 26 }" :maxlength="65536"
                    v-model="descriptionBOJson[langActiveTab][descActiveTab]" placeholder="请输入..." :disabled="isDisabled" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 多属性资料 -->
      <div class="tag-comtent-item" v-show="pageEditTag == 'multiattribute'">
        <productMultiattribute
          v-if="pageTagView['multiattribute']"
          ref="productMultiattributeRef"
          :productInfo.sync="productInfo"
          :skuData.sync="skuData"
          :skuPropertyList.sync="skuPropertyList"
          :isDisabled="isDisabled"
          :pageEditTag="pageEditTag"
          :pageTagView="pageTagView"
          :customProductTagList="customProductTagList"
          :productStatus="productStatus"
          :treeSelectCategoryJson="treeSelectCategoryJson"
          :textTalg="textTalg"
          :columnSizeOrModel="columnSizeOrModel"
          :initFinished="initFinished"
          :isOldData="isOldData"
          :sizeList="sizeList"
          :colorList="colorList"
          @edit-sku-image="editSkuImage"
          @edit-distribution="editDistribution"
          @edit-assemble="editAssemble"
          @bind-size-group="bindSizeGroupNo"
        />
      </div>
      <!-- 生产资料 -->
      <div class="tag-content-productionInfo tag-comtent-item" v-show="pageEditTag == 'productionInfo'">
        <div v-if="pageTagView['productionInfo']">
          <!-- 采购要求信息 -->
          <div class="sxContent flex-70" v-if="!isSupplierTalg">
            <div class="productsTit padding-10">
              <div id="customs">
                采购要求信息
              </div>
            </div>
            <div class="products-content purchase-content padding-10">
              <FormItem label="水洗唛成分:" prop="washedLabel" :label-width="90">
                <Input class="textarea-resize-none" v-model="productInfo.washedLabel" placeholder="请输入水洗唛成分，最多300字符"
                  type="textarea" :maxlength="300" clearable :autosize="{ minRows: 2, maxRows: 4 }"
                  :disabled="isDisabled" />
              </FormItem>
              <!-- <FormItem label="水洗唛养护说明:" prop="washedLabelMaintainDesc" :label-width="95">
                <Input class="textarea-resize-none" v-model="productInfo.washedLabelMaintainDesc" placeholder="请输入水洗唛养护说明，最多300字符"
                  type="textarea" :maxlength="300" clearable :autosize="{ minRows: 2, maxRows: 4 }"
                  :disabled="isDisabled" />
              </FormItem> -->
              <FormItem label="水洗唛养护说明:" prop="washableLabelInfoId" :label-width="95">
                <dytSelect v-model="productInfo.washableLabelInfoId" :disabled="isDisabled" placeholder="请选择水洗唛养护说明">
                  <Option
                    v-for="(item, mIndex) in washableDataList"
                    :key="`${item.id}-${mIndex}`"
                    :value="item.id"
                    :label="item.maintenanceInstructions"
                  />
                </dytSelect>
              </FormItem>
              <FormItem label="" prop="washableLabelInfoId" :label-width="0">
                <div v-if="washableDataJson[productInfo.washableLabelInfoId]" class="washable-label-view">
                  <Poptip trigger="hover" title="" placement="right-start" v-if="washableDataJson[productInfo.washableLabelInfoId].picturePath">
                    <img
                      :src="`${filenodeViewTargetUrl}${washableDataJson[productInfo.washableLabelInfoId].picturePath}`"
                      @click="previewImg(`${filenodeViewTargetUrl}${washableDataJson[productInfo.washableLabelInfoId].picturePath}`)"
                      class="washable-pic-view"
                      title="点击预览图片原图"
                    />
                    <div slot="content">
                      <img
                        :src="`${filenodeViewTargetUrl}${washableDataJson[productInfo.washableLabelInfoId].picturePath}`"
                        class="washable-max-pic-view"
                      />
                    </div>
                  </Poptip>
                  <div class="washable-pdf-view ml5" v-if="washableDataJson[productInfo.washableLabelInfoId].pdfPath">
                    <span @click="previewWashedPdf(washableDataJson[productInfo.washableLabelInfoId].pdfPath)" title="点击预览PDF文件">
                      {{ washableDataJson[productInfo.washableLabelInfoId].pdfName }}
                    </span>
                  </div>
                </div>
              </FormItem>
              <Form-item prop="washedLabelPdfPath" :label-width="120">
                <div slot="label">
                  <div>水洗唛文件：</div>
                  <div>(PDF/JPG/PNG)</div>
                </div>
                <dytUpload v-show="false" ref="washedUploadRef" file-name="files" :show-upload-list="false"
                  accept="application/pdf,image/jpg,image/jpeg,image/png" :before-upload="washedUploadBefore"
                  :action="uploadFilesUrl" />
                <div class="washed-operate">
                  <Poptip trigger="hover" placement="left" v-if="!$common.isEmpty(productInfo.washedLabelPdfPath)" transfer>
                    <div class="washed-image-content">
                      <img :src="pdfFirstImgPreview" @click="previewWashedPdf(productInfo.washedLabelPdfPath)" />
                      <Spin fix v-if="isWashedUploadLoading"></Spin>
                    </div>
                    <div class="washed-image-preview-content" slot="content">
                      <img :src="pdfFirstImgPreview" @click="previewWashedPdf(productInfo.washedLabelPdfPath)" />
                    </div>
                  </Poptip>
                  <span class="click-text-underline" @click="opentCheckFile"
                    v-if="!isDisabled && $common.isEmpty(productInfo.washedLabelPdfPath)">
                    点击上传
                    <Spin fix v-if="isWashedUploadLoading"></Spin>
                  </span>
                  <template v-if="!$common.isEmpty(productInfo.washedLabelPdfPath)">
                    <span class="click-text-underline" @click="previewWashedPdf(productInfo.washedLabelPdfPath)">预览</span>
                    <span class="click-text-underline" @click="opentCheckFile" v-if="!isDisabled">更换</span>
                    <span class="click-text-underline" v-if="!isDisabled" @click="removeWashedPdf">删除</span>
                  </template>
                </div>
              </Form-item>
              <Form-item label="水洗唛word文件：" prop="washedLabelWordPath" :label-width="130">
                <uploadSampleFile v-model="productInfo.washedLabelWordFile" :disabled="isDisabled"
                  accept-error-txt="文件格式不对，请上传格式为 docx、doc 的 word文档格式文件" :file-max-size="30" :upload-props="{
                    multiple: false,
                    accept: [
                      'application/msword',
                      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                    ]
                  }" />
              </Form-item>
              <Form-item label="纸样文件：" prop="patternFile" :label-width="120">
                <uploadSampleFile v-model="productInfo.patternFile" :disabled="isDisabled"
                  accept-error-txt="文件格式不对，请上传格式为 pdf、excel、prj 的文件" :file-max-size="30" :upload-props="{
                    multiple: true,
                    accept: [
                      '.prj',
                      'application/pdf',
                      'application/vnd.ms-excel',
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    ]
                  }" />
              </Form-item>
              <FormItem label="SPU生产要求:" prop="outerPackageRequirement"
                :rules="{ validator: validateOutPack, trigger: 'change' }" :label-width="90">
                <Input class="textarea-resize-none" v-model.trim="productInfo.outerPackageRequirement"
                  placeholder="请输入SPU生产要求，最多200字符" type="textarea" clearable :autosize="{ minRows: 2, maxRows: 4 }"
                  :disabled="isDisabled" />
              </FormItem>
              <Form-item label="生产尺码图：" :label-width="120">
                <div class="washed-operate">
                  <Poptip trigger="hover" placement="left" v-if="!$common.isEmpty(dimensionPlan)">
                    <div class="washed-image-content">
                      <img :src="dimensionPlan" @click="previewImg(dimensionPlan)" />
                    </div>
                    <div class="washed-image-preview-content" slot="content">
                      <img :src="dimensionPlan" @click="previewImg(dimensionPlan)" />
                    </div>
                  </Poptip>
                  <img v-else :src="placeholderSrc"
                    style="width: 46px; height: 46px; object-fit: cover; vertical-align: middle; cursor: pointer;">
                  <template v-if="!$common.isEmpty(dimensionPlan)">
                    <span class="click-text-underline" @click="previewImg(dimensionPlan)">预览</span>
                    <span class="click-text-underline" v-if="!isDisabled" @click="removePlanImg">删除</span>
                  </template>
                </div>
              </Form-item>
              <Form-item label="其他附件：" prop="attachmentPath" :label-width="120">
                <uploadSampleFile
                  v-model="productInfo.attachmentPath"
                  :disabled="isDisabled"
                  :file-max-size="5"
                  :max-file-number="5"
                  :showSuffix="true"
                  :upload-props="{
                    multiple: true,
                    accept: [],
                  }"
                />
              </Form-item>
            </div>
          </div>
          <!-- 物料资料 -->
          <div class="sxContent products-content flex-70">
            <div class="productsTit padding-10">
              <div id="customs">
                物料资料
              </div>
            </div>
            <materialData ref="materialRefDemo" :productData="productInfo" :disabled="isDisabled"
              :modelVisible="!spinShow" />
          </div>
          <!-- 其他费用 -->
          <div class="sxContent products-content flex-70">
            <div class="productsTit padding-10">
              <div id="customs">
                其他费用
              </div>
            </div>
            <laPaFeeType ref="refLaPaFeeType" :productData="productInfo" :disabled="isDisabled" :modelVisible="!spinShow" />
          </div>
          <!-- 工艺要求说明 -->
          <div class="sxContent products-content flex-70">
            <div class="productsTit padding-10">
              <div id="customs">
                工艺要求说明
              </div>
            </div>
            <processRequire ref="processRequireInstructionsRef" :productData="productInfo" :disabled="isDisabled" :modelVisible="!spinShow" />
          </div>
        </div>
      </div>
      <!-- 销售链接 -->
      <div class="tag-comtent-item" v-show="pageEditTag == 'salesLink'">
        <salesLinkView
          v-if="isDisabled && pageTagView['salesLink']"
          :module-data="salesViewData"
          :module-visible="pageEditTag == 'salesLink' && isDisabled"
        />
      </div>
      <!-- GPSR资料 -->
      <div class="tag-comtent-item" v-show="pageEditTag == 'gpsrInfo'">
        <gpsrView
          v-if="editProductModal && pageTagView['gpsrInfo']"
          :module-data="gpsrViewData"
          @refreshList="refreshList"
          :is-disabled="isDisabled"
        />
      </div>
    </Form>
    <!-- SKU 图套配置弹框（已拆分为独立组件） -->
    <skuImageSetModal
      ref="skuImageSetModalRef"
      :product-id="productInfo.productId"
      :sku-data.sync="skuData"
      :multi-lang-image-data.sync="multiLangImageData"
      :is-disabled="isEditPicture ? false : isDisabled"
    />

    <!-- 表格弹框 -->
    <table-edit :isVisible.sync="isVisible" :type="type" :languageType="langActiveTab"
      @tableEditcontent="tableEditcontent"></table-edit>

    <!-- 返回顶部 -->
    <!-- <BackTop></BackTop> -->
    <!-- 添加组装模态框 -->
    <addAssembleModal ref="addAssembleModal" @addTabData="addTabData" :openType="openType"
      :editAssembleIndex="editAssembleIndex"></addAssembleModal>

    <!-- 通用、女鞋尺码图 -->
    <sizeChart :chartModalVisible.sync="chartModalVisible" :productCategoryListData="productCategoryListData"
      :productInfo="productInfo" :sizeTypeFar="sizeTypeFar" :colorList="colorList" :sizeList="sizeList"
      :planType="planType" :skuPropertyList="skuPropertyList" @getSizePicture="getSizePicture"
      @insetDescription="insetDescription" :editStatus="editStatus" />

    <!-- 婴童、儿童尺码图 -->
    <child-size-chart :isVisible.sync="childVisible" :childType="planType" :productInfo="productInfo"
      @getSizePicture="getSizePicture" :productCategoryListData="productCategoryListData"
      @insetDescription="insetDescription" :editStatus="editStatus" />
    <!-- 分销编辑 -->
    <editDistribution :modelVisible.sync="distributionVisible" :distribution-info="distributionInfo"
      @distributionConfirm="distributionConfirm" />
    <!-- 绑定尺码组弹窗 -->
    <bindSizeGroupModal :modelVisible.sync="bindSizeGroupVisible" :moduleData="bindSizeModuleData"
      @confirmModal="editAttributes" />
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import api from '@/api/api';
import UE from '@/components/ue/ue.vue';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
import productMixin from '@/components/mixin/product_mixin';
import addAssembleModal from './addAssembleModal';
import productData from '@/views/productCenter/components/productCenter/staticData/productData';
import sizeChart from '@/views/productCenter/components/productCenter/sizeChart/sizeChart';
import childSizeChart from '@/views/productCenter/components/productCenter/sizeChart/childSizeChart';
import tableEdit from '@/components/tableEdit/index.vue';
import 'viewerjs/dist/viewer.css'
import qualityInspectionStandard from './qualityInspectionStandard';
import bindSizeGroupModal from './bindSizeGroupModal';
import editDistribution from './editDistribution';
import uploadSampleFile from './uploadSampleFile';
import productImageInfo from './productImageInfo';
import skuImageSetModal from './skuImageSetModal';
import productMultiattribute from './productMultiattribute';
import materialData from './materialData';
import laPaFeeType from './laPaFeeType';
import processRequire from './processRequire';
import salesLinkView from './salesLinkView';
import productAttribute from './productAttribute';
import productPlatformCategory from './productPlatformCategory';
import gpsrView from './gpsrView';
import { imageTypeData } from '@/utils/constantData';

const showTabKey = ['baseInfo', 'productionInfo'];

export default {
  mixins: [Mixin, tableMixin, productMixin],
  components: {
    UE,
    addAssembleModal,
    sizeChart,
    childSizeChart,
    tableEdit,
    editDistribution,
    qualityInspectionStandard,
    uploadSampleFile,
    productImageInfo,
    skuImageSetModal,
    productMultiattribute,
    materialData,
    // sewingLaborRrate,
    // technologicalRequire,
    // twiceCraftRequire,
    // frameHoppingData,
    // washedSginModal,
    laPaFeeType,
    processRequire,
    bindSizeGroupModal,
    salesLinkView,
    productAttribute,
    productPlatformCategory,
    gpsrView
  },
  // 分类  品牌  特性标签  详情数据id
  props: {
    editProductModal: {
      type: Boolean,
      default: false
    },
    productCategoryListData: {
      type: Array,
      default: () => {
        return []
      }
    },
    productCategoryIds: {
      type: Array,
      default: () => {
        return []
      }
    },
    productBrandList: {
      type: Array,
      default: () => {
        return []
      }
    },
    productTagList: {
      type: Array,
      default: () => {
        return []
      }
    },
    productId: {
      type: String,
      default: ''
    },
    ymsMenuList: {
      type: Array,
      default: () => {
        return []
      }
    },
    editStatus: {
      type: String,
      default: ''
    },
    originalCategoryData: {
      type: Array,
      default: () => {
        return []
      }
    },
    productGoodsListDictionary: {
      type: Object,
      default: () => {
        return {}
      }
    },
    productGoodsListDictionaryData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    otherData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    var self = this;
    return {
      editPageLoaing: false,
      washableDataList: [],
      washableDataJson: {},
      pictureTypeData: imageTypeData,
      pageEditTag: 'baseInfo',
      pageTagView: {},
      uploadOtherAttachment: api.uploadAttachment, // 商品其他附件上传 API
      tagList: [
        { label: '基础资料', value: 'baseInfo' },
        { label: '多属性资料', value: 'multiattribute' },
        { label: '生产资料', value: 'productionInfo' },
        { label: '销售链接', value: 'salesLink', powerKey: 'sales' },
        { label: 'GPSR资料', value: 'gpsrInfo' }
      ],
      bindSizeGroupVisible: false,
      bindSizeModuleData: {},
      distributionVisible: false,
      specificationsObj: {},
      distributionInfo: {},
      qualityProductArray: [],
      childVisible: false,
      planType: null,
      isWashedUploadLoading: false,
      // 编织类型：0-针织 1-梭织 2-毛织
      braidDataList: [
        { label: '针织', value: 0 },
        { label: '梭织', value: 1 },
        { label: '毛织', value: 2 }
      ],
      validateCol: {
        isWeight: [],
        isLength: [],
        isWidth: [],
        isHeight: [],
        isSuggestPrice: []
      },
      languageTab: [
        { key: 'EN', label: '英语' },
        { key: 'GER', label: '德语' },
        { key: 'FRA', label: '法语' },
        { key: 'SPN', label: '西班牙语' },
        { key: 'IT', label: '意大利语' },
        { key: 'POR', label: '葡萄牙语' },
        { key: 'CN', label: '中文' },
        { key: 'PLN', label: '波兰语' }
      ],
      descriptionTab: [
        { key: 'description', label: '复杂描述' },
        { key: 'simpleDescription', label: '简易描述' },
        { key: 'textDescription', label: '纯文本描述' },
        { key: 'highlightDescription', label: '亮点描述' },
        { key: 'packageDescription', label: '包裹描述' },
        { key: 'mobileDescription', label: '移动端描述' }
      ],
      langActiveTab: 'EN',
      descActiveTab: 'description',
      oldActiveLang: 'EN', // 语言类型切换时给变量赋值
      oldActiveDesc: 'description', // 描述类型切换时给变量赋值
      descriptionBOJson: {},
      productStatus: productData.productStatus,
      initGetTreeData: true,
      treeSelectCategoryValue: '',
      treeSelectCategoryJson: {},
      businessRoleTypeList: [],
      minWidth: 200, // 表格制定列最小宽度
      waitingOk: false, // 点击确认按钮是否需要显示loading遮罩
      initFinished: false, // 是否初始化完成
      customProductTagList: [], // 这个标签列表包含自定义标签
      productInfoPrototype: null, // 当前商品信息原型
      checkedProductGoodsImages: [], // 已被选中的货品图片
      productGoodsPrimaryImage: null, // 货品主图
      filenodeViewTargetUrl: self.$store.state.erpConfig.filenodeViewTargetUrl, // filenode根路径
      uploadFilesUrl: api.upload_files + '?basePath=/product', // 上传url（水洗唛上传复用）
      skuPropertyList: [], // 商品多属性列表
      config: { // 富文本编辑器 配置
        initialFrameWidth: null,
        initialFrameHeight: 500,
        serverUrl: api.product_ueditor_enter,
        wordCount: false
      },
      productCategoryTree: [ // 商品分类树
        {
          title: '全部',
          expand: true,
          productCategoryId: 'productCategoryId1',
          disabled: true,
          children: []
        }
      ],
      specificationColorList: [ // 规格颜色
        '#169BD5', '#009900', '#763EAF', '#CC0033', '#FF9900', '#999999', '#33CC99', '#663300'
      ],
      salesViewData: {},
      // gpsr 信息
      gpsrViewData: {},
      productInfo: { // 产品信息
        materialCnDesc: '',
        materialEnDesc: '',
        usageCnDesc: '',
        usageEnDesc: '',
        productId: '',
        braidType: null,
        type: 1,
        cnName: null,
        enName: null,
        spu: null,
        cnHsName: null,
        enHsName: null,
        // description: '',
        descriptionBOList: [],
        hsCode: null,
        checkType: '0',
        checkRate: '0',
        minCheckNum: null,
        newSupplierCheck: false,
        basicSpecificationVerification: false,
        productBrandId: null,
        productCategoryId: null,
        ymsProductCategoryId: null,
        productImages: [],
        washedLabel: "", // 水洗唛成分
        // washedLabelMaintainDesc: '', // 水洗唛养护说明
        washableLabelInfoId: '',
        patternFile: '', // 纸样文件
        attachmentPath: '', // 其他附件
        instructionsPath: '', // 附件说明书path多个逗号隔开
        washedLabelWordFile: {}, // 水洗唛WORD 文件
        washedLabelWordPath: '', // 水洗唛WORD路径
        washedLabelWordName: '', // 水洗唛WORD名称
        productGoodsMaterialInfoVOList: [], // 物料信息
        laPaApiProductTechnologyVOList: [], // 工艺信息
        machiningRate: null, // 工序(车缝工价)-加工倍率
        productProcessVOList: [], // 工序信息
        productManufactureVOList: [], // 尺码信息(跳码表)
        washedLabelPdfPath: null,
        washedLabelPdfName: null,
        outerPackageRequirement: '', //  生产要求
        productGoodsList: [
          {
            productGoodsId: null,
            sku: null,
            ean: null,
            upc: null,
            isbn: null,
            width: 0,
            height: 0,
            length: 0,
            weight: 0,
            status: 1,
            suggestPrice: 0,
            samplePrice: 0,
            sampleFreight: 0,
            productGoodsTags: [],
            productGoodsImages: [],
            productGoodsSpecifications: [],
            productTypeListValue: ['01'],
            productionRequirement: '', // sku 生产要求
            isAssemble: false, // 是否组装
            editStatus: false, // 是否重新编辑
            productGoodsAssembles: [], // 组装信息
            embryonicClothSku: null, // 胚衣SKU
            embryonicClothDescription: null, //  胚衣描述
            printingImagePath: null, // 印花图案URL
          }
        ],
        operationType: 1, // 操作类型 0 暂存 1 提交
        deliveryInterval: 1,
        specialMarkList: [],
      },
      specialMarkOption: [
        {
          value: '0',
          label: '抽真空'
        },
      ],
      deliveryIntervalList: [
        {
          value: 1,
          name: '1天'
        },
        {
          value: 2,
          name: '2天'
        },
        {
          value: 3,
          name: '3天'
        },
        {
          value: 4,
          name: '4天'
        },
        {
          value: 5,
          name: '5天'
        },
        {
          value: 6,
          name: '6天'
        },
        {
          value: 7,
          name: '7天'
        }
      ],
      skuData: [], // 货品数据
      editAssembleIndex: null, // 变参组装信息  当前编辑的下表
      openType: null, // 1 普通商品  2 变参商品
      categoryList: [], // 类目
      sizeChartdata: [],
      sizeChartColumns: [],
      classifyTalg: 'edit', // 记录在编辑页面云卖分类的状态： look -- 查看状态， edit-- 编辑状态， change -- 切换其他云卖分类模板
      templateObj: {},
      editObj: {},
      sizeJsonData: {},
      hideSizeChart: true,
      editor: null,
      oldAttrChange: false,
      selectedValue: '',
      colorList: [],
      sizeList: [],
      visible: false,
      chartModalVisible: false,
      commodiAttr: {
        laPaProductVariQuotationList: []
      },
      categoryChange: false,
      sizeTypeFar: null,
      productTypeFar: '',
      spinShow: true,
      isLoadInfo: true,
      firstProductInfo: {},
      isOldData: false,
      columnSizeOrModel: '',
      isVisible: false,
      type: null,
      pdfFirstImgPreview: '',
      pageGpsrInfo: {},
      pageProductGoodsId: [],
      multiLangImageData: [],
    };
  },
  watch: {
    pageEditTag: {
      immediate: true,
      deep: true,
      handler (val) {
        if (this.$common.isEmpty(val) || this.pageTagView[val]) return;
        if (this.$common.isUndefined(this.pageTagView[val])) {
          this.$set(this.pageTagView, val, true);
        } else {
          this.pageTagView[val] = true;
        }
      }
    },
    // 监听多文本输入
    initFinished(n) {
      if (n) {
        this.$nextTick(() => {
          this.editor = this.$refs['descdomeue'].editor;
          let userInfo = this.$store.state.erpConfig.userInfo;
          this.editor.addListener('ready', () => {
            this.editor.execCommand('serverparam', {
              'basePath': 'product-service',
              'userId': userInfo.merchantId + ',' + userInfo.userId
            })
          })
          this.$nextTick(() => {
            let content = this.descriptionBOJson[this.langActiveTab] && this.descriptionBOJson[this.langActiveTab][this.descActiveTab];
            this.editor.setContent(content);
          })
        })
      }
    },
    checkedProductGoodsImages(n, o) { // 如果不勾选图片那么切换主图
      if (this.checkedProductGoodsImages.indexOf(this.productGoodsPrimaryImage) === -1) {
        this.productGoodsPrimaryImage = this.checkedProductGoodsImages[0] || null;
      }
    },
    productGoodsPrimaryImage(n, o) { // 勾选主图时如果没有选择那么默认勾选上
      if (this.checkedProductGoodsImages.indexOf(n) === -1) {
        this.checkedProductGoodsImages.push(n);
      }
    },
    // 监听窗口显示隐藏,隐藏时重置数据
    editProductModal: {
      immediate: true,
      deep: true,
      handler(n) {
        if (n) { // 初始化数据
          this.categoryChange = false;
          this.isOldData = false;
          this.spinShow = true;
          this.$set(this.gpsrViewData, 'productId', this.productId);
          this.$set(this.gpsrViewData, 'productGoodsListDictionary', this.productGoodsListDictionaryData);
          this.$set(this.gpsrViewData, 'permission', this.permission);
          this.pageGpsrInfo = {};
          // 商品其他附件上传 API
          this.uploadOtherAttachment = `${api.uploadAttachment}/${this.productId}`;
          // 获取商品详情
          this.axios.get(api.productInfo_detail + this.productId).then(response => {
            if (response.data.code === 0) {
              let productInfo = response.data.datas;
              productInfo.newSupplierCheck = productInfo.newSupplierCheck == 1;
              productInfo.basicSpecificationVerification = productInfo.basicSpecificationVerification == 1;
              this.pageProductGoodsId = (productInfo.productGoodsList || []).map(m => m.productGoodsId);
              this.getGpsrInfo(this.pageProductGoodsId);
              this.$set(productInfo, 'washedLabelWordFile', {});
              if (!this.$common.isEmpty(productInfo.washedLabelWordPath)) {
                productInfo.washedLabelWordFile.fileName = productInfo.washedLabelWordName || productInfo.washedLabelWordPath;
                productInfo.washedLabelWordFile.fileUrl = productInfo.washedLabelWordPath;
              }
              const url = productInfo.washedLabelPdfPath;
              if (!this.$common.isEmpty(url)) {
                this.isWashedUploadLoading = true;
                const suffix = url.substring(url.lastIndexOf('.'), url.length);
                if (suffix.toLocaleLowerCase() == '.pdf') {
                  this.$common.getPdfRes({
                    pdfUrl: `./filenode/s${url}`,
                    pageNumber: 1,
                    scale: 10
                  }).then(img => {
                    this.pdfFirstImgPreview = img;
                  }).finally(() => {
                    this.isWashedUploadLoading = false;
                  })
                } else {
                  this.pdfFirstImgPreview = `./filenode/s${url}`;
                  this.isWashedUploadLoading = false;
                }
              }
              this.firstProductInfo = this.deepCopy(response.data.datas)
              this.initCategoryTree(productInfo.productCategoryId);
              // 销售链接数据
              this.salesViewData = {
                productGoodsList: productInfo.productGoodsList || [],
                list: productInfo.productGoodsPlatformUrls || []
              };
              if (this.isSupplierTalg) {
                if (productInfo.ymsProductCategoryId) {
                  this.initYmsCategoryTree(productInfo.ymsProductCategoryId);
                  if (this.isDisabled) {
                    this.handlerTemplate(productInfo.productSizeList, productInfo.ymsProductCategoryId);
                    this.classifyTalg = 'look';
                  } else {
                    // 判断当前的商品是否已经过尺码模板
                    if (productInfo.sizeJson === null) {
                      this.classifyTalg = 'change';
                      this.getTemplateData(productInfo.ymsProductCategoryId);
                    } else {
                      this.classifyTalg = 'edit';
                      this.handlerTemplate(productInfo.productSizeList, productInfo.ymsProductCategoryId);
                      this.sizeJsonData = JSON.parse(productInfo.sizeJson);
                    }
                  }
                }
              }
              this.$nextTick(() => {
                this.checkOldData();
                this.initProductInfo(productInfo);
                this.reloadSkuColumn();
                this.getSizeList().then(() => {
                  this.disabledTreeItem();
                });
                this.loadPicture();
                setTimeout(() => {
                  this.initFinished = true;
                  this.initProductGoods(productInfo.productGoodsList || []);
                  /* if (this.skuPropertyList.length == 0) {
                    this.addColorSize();
                  } */
                }, 100)
                this.$set(this.gpsrViewData, 'productInfo', productInfo);
                this.delayTabShow();
              });
              this.isLoadInfo = false;
            } else {
              this.delayTabShow();
            }
          }).catch(() => {
            this.delayTabShow();
          });
          this.$parent.$parent.productId = null;
          this.$refs.editSpu.scrollTop = 0;
          this.customProductTagList = this.deepCopy(this.productTagList);
        } else {
          this.locationErrorInput('baseInfo');
          this.isLoadInfo = true;
          this.spinShow = true;
          this.delayTabShow(true);
        }
      }
    },
    skuPropertyList: {
      handler(data) {
        if (this.classifyTalg === 'edit') {
          if (data.length > 0) {
            data.map((item) => {
              if (item.name === '尺码') {
                item.values.map((ele) => {
                  this.sizeChartdata.push(Object.assign({}, this.editObj, { sizeCode: ele }));
                });
              }
            });
            this.sizeChartdata = this.uniqueFunc(this.sizeChartdata, 'sizeCode');
          }
        } else if (this.classifyTalg === 'change') {
          this.sizeChartdata = [];
          if (data.length > 0) {
            data.map((item) => {
              if (item.name === '尺码') {
                item.values.map((ele) => {
                  this.sizeChartdata.push(Object.assign({}, { size: ele }, this.templateObj));
                });
              }
            });
          }
        }
      },
      deep: true
    },
    'productInfo.checkType': {
      deep: true,
      handler(val) {
        if ([0, '0'].includes(val)) {
          this.$set(this.productInfo, 'checkRate', '0');
          this.$set(this.productInfo, 'minCheckNum', null);
          return;
        }
        if ([1, '1'].includes(val)) {
          const rate = Number(this.productInfo.checkRate);
          const lastRate = this.$common.isEmpty(rate) ? '1' : rate > 1 && rate < 100 ? Math.floor(rate).toString() : '1';
          this.$set(this.productInfo, 'checkRate', lastRate);
          return;
        }
        if ([2, '2'].includes(val)) {
          this.$set(this.productInfo, 'checkRate', '100');
        }
      }
    },
    /** 当子组件同步 skuData 时，确保 productInfo.productGoodsList 保持一致 */
    skuData: {
      deep: true,
      handler(val) {
        if (this.$common.isEmpty(val)) return;
        const newStr = JSON.stringify(val);
        const oldStr = JSON.stringify(this.productInfo.productGoodsList);
        if (newStr !== oldStr) {
          this.$set(this.productInfo, 'productGoodsList', this.deepCopy(val));
        }
      }
    },
    /**
     * 监听 multiLangImageData 变化，同步到 productInfo.productImages（SKU弹框数据源）
     * productImageInfo 上传/删除/排序图片后，SKU弹框的图库随之更新
     */
    multiLangImageData: {
      deep: true,
      handler(val) {
        if (this.$common.isEmpty(val)) return;
        const newProductImages = val.map(group => ({
          language: group.language,
          images: (group.images || []).map(img => ({ ...img }))
        }));
        const newStr = JSON.stringify(newProductImages);
        const oldStr = JSON.stringify(this.productInfo.productImages);
        if (newStr !== oldStr) {
          this.$set(this.productInfo, 'productImages', newProductImages);
        }
      }
    }
  },
  beforeCreate() {

  },
  created() {
    this.editPageLoaing = true;
    this.textInit();
    this.productInfoPrototype = this.deepCopy(this.productInfo);
    this.$common.promiseAll([
      this.getCommodityDeveloper, // 获取开发员
      this.getColorList, // 获取颜色数据
      this.getWashableList, // 获取水洗唛数据
    ]).finally(() => {
      this.editPageLoaing = false;
    });
  },
  computed: {
    // 是否为服装分类类型
    isClothingType() {
      const selectCategoryType = this.getTypeInfo(this.treeSelectCategoryValue);
      if (this.$common.isEmpty(selectCategoryType)) return false;
      return selectCategoryType.productType == '0';
    },
    // 颜色所有值
    getColorAll() {
      if (this.$common.isEmpty(this.colorList)) return [];
      return this.colorList.map(m => m.color);
    },
    // 获取尺码末级的值
    getSizeVal() {
      if (this.$common.isEmpty(this.sizeList)) return [];
      const sizeVal = this.handSizeList(this.sizeList);
      return sizeVal;
    },
    // 是否存在多余的多属性
    isAttrTips() {
      const notItem = this.skuPropertyList.filter((item, index) => {
        if (index == 0 && this.sizeList.length != 0 && !this.isOldData) {
          return !this.$common.isEmpty(item.values.find(f => {
            return !this.getColorAll.includes(f);
          }));
        } else if (index == 1 && this.sizeList.length != 0 && !this.isOldData) {
          return !this.$common.isEmpty(item.values.find(f => {
            return !this.getSizeVal.includes(f);
          }));
        }
        return false;
      })
      return !this.$common.isEmpty(notItem);
    },
    // 尺码图
    dimensionPlan() {
      if (this.$common.isEmpty(this.productInfo)) return '';
      let sizeImageList = this.productInfo.productImageTypeList || [];
      if (this.$common.isEmpty(sizeImageList)) {
        sizeImageList = this.productInfo.productImageList || [];
      }
      if (this.$common.isEmpty(sizeImageList)) return '';
      const planImgObj = sizeImageList.find(f => {
        return [2, 3, 4, '2', '3', '4'].includes(f.imageType);
      })
      if (this.$common.isEmpty(planImgObj)) return;
      return `${this.filenodeViewTargetUrl}${planImgObj.path}`;
    },
    permission() {
      return {
        synchronous: this.getPermission('productInfo_synListing'), // 同步Listing权限
        update: this.getPermission('productInfo_update'), // 编辑商品详情权限
        gpsrTemplate: this.getPermission('gpsr_templateManage'), // gpsr 模板权限
        editGpsr: this.getPermission('gpsr_edit'), // 编辑 gpsr 资料权限
        deleteGpsr: this.getPermission('gpsr_delete'), // 删除 gpsr 资料权限
        deleteBritain: this.getPermission('gpsr_britainAgentInfoDelete'), // GPSR填写模板-删除英代信息
        deleteEurope: this.getPermission('gpsr_europeAgentInfoDelete'), // GPSR填写模板-删除欧代信息
        deleteIdent: this.getPermission('gpsr_identificationInfoDelete'), // GPSR填写模板-删除标识信息
        deleteManu: this.getPermission('gpsr_manufacturerInfoDelete'), // GPSR填写模板-删除生产商信息
        deleteWarning: this.getPermission('gpsr_securityWarningInfoDelete'), // GPSR填写模板-删除安全警告信息
        sales: this.isDisabled,
      }
    },
    // 是否禁用编辑
    isDisabled() {
      if (this.isEditPicture) return true;
      if (this.editStatus === 'add') return false;
      if (this.editStatus === 'eidt') return !this.permission.update;
      return this.editStatus === 'look';
    },
    isEditPicture() {
      return this.editStatus === 'editPicture';
    },
    // 是否是供应商商户
    isSupplierTalg() {
      return this.$store.state.erpConfig.merchant.isSupplier === 1;
    },
    textTalg() {
      return this.$store.state.erpConfig.merchant.isSupplier === 1
        ? '分销价格'
        : '采购成本价';
    }
  },
  methods: {
    // 平台类目变化回调：同步到 productInfo
    handlePlatformCategoryChange () {},
    handSizeList(data, oldVal = [], key) {
      let valList = [...oldVal];
      data.forEach(item => {
        if (!item.disabled) {
          if (item.children) {
            valList = [...valList, ...this.handSizeList(item.children, valList, 'key')];
          } else {
            valList.push(item.size);
          }
        }
      });
      return this.$common.arrRemoveRepeat(valList);
    },
    // 获取水洗唛数据
    getWashableList () {
      this.washableDataList = [];
      this.washableDataJson = {};
      return new Promise((resolve) => {
        this.axios.post(api.washableQueryList, {
          maintenanceInstructions: null
        }).then(res => {
          if (res && res.data && res.data.code == 0) {
            (res.data.datas || []).forEach(item => {
              this.$set(this.washableDataJson, item.id, item);
            });
            this.washableDataList = res.data.datas || [];
            resolve({ state: 'finally', data: res.data.datas || [] });
            return;
          }
          resolve({ state: 'finally', data: [] });
        }).catch(() => {
          resolve({ state: 'finally', data: [] });
        })
      })
    },
    // 获取对应商品是否有 GPSR 资料
    getGpsrInfo (productGoodsIds = []) {
      return new Promise((resolve) => {
        if (this.$common.isEmpty(productGoodsIds)) return resolve({ data: [] });
        this.axios.post(api.queryGpsrLabelInfo, productGoodsIds).then(res => {
          if (!res || !res.data || res.data.code != 0) return resolve({ data: [] });
          this.pageGpsrInfo = this.$common.isEmpty(res.data.datas) ? {} : res.data.datas[0];
          return resolve({ data: res.data.datas || [] });
        }).catch(() => {
          resolve({ data: [] });
        })
      })
    },
    // 需要移除的表格列
    removeTableColumn () {
      // 当详情为空或 isSnapwear 不为1时
      let removeKey = [];
      if (this.$common.isEmpty(this.productInfo) && ![1].includes(Number(this.productInfo.isSnapwear))) {
        removeKey = ['embryonicClothSku', 'embryonicClothDescription', 'printingImagePath'];
        this.skuColumns = this.skuColumns.filter(item => {
          return !removeKey.includes(item.key);
        });
      }
    },
    // 延迟显示对应的必要 tab 标签页面
    delayTabShow (type = false) {
      let hIndex = 0;
      const hand = (key) => {
        if (this.$common.isUndefined(this.pageTagView[key])) {
          this.$set(this.pageTagView, key, true);
        } else if (!this.pageTagView[key]) {
          this.pageTagView[key] = true;
        }
        this.$nextTick(() => {
          setTimeout(() => {
            hIndex++;
            if (!this.$common.isEmpty(showTabKey[hIndex])) {
              hand(showTabKey[hIndex]);
            } else if (!type) {
              this.spinShow = false;
            }
          }, 300)
        })
      };
      if (!this.$common.isEmpty(showTabKey[hIndex])) {
        hand(showTabKey[hIndex]);
      }
    },
    // 往前追溯分类类型，直到找到为止或全部
    getTypeInfo(id) {
      if (this.$common.isEmpty(this.treeSelectCategoryJson) || this.$common.isEmpty(id)) return null;
      const getInfo = this.treeSelectCategoryJson[id];
      if (this.$common.isEmpty(getInfo)) return null;
      if (this.$common.isEmpty(getInfo.productType)) {
        if (this.$common.isEmpty(getInfo.parentId)) return null;
        return this.getTypeInfo(getInfo.parentId);
      }
      return getInfo;
    },
    // 数据格式
    textInit(data = [], productId) {
      const additional = ['productId', 'title', 'keywords', 'language', 'descriptionId'];
      this.languageTab.forEach(item => {
        this.$set(this.descriptionBOJson, item.key, {});
        const langCont = data.filter(cont => {
          return item.key == cont.language;
        })
        additional.forEach(key => {
          if (langCont[0]) {
            let val = langCont[0][key];
            if (key == 'keywords') {
              val = langCont[0][key] || [];
              if (!Array.isArray(langCont[0][key]) && !this.$common.isEmpty(langCont[0][key])) {
                val = (langCont[0][key].split(',')).filter(isVal => {
                  return !!isVal
                }).map(newVal => {
                  return { attrVal: newVal }
                })
              }
            } else if (key == 'productId') {
              val = langCont[0][key] ? langCont[0][key] : productId || '';
            }
            this.$set(this.descriptionBOJson[item.key], key, val);
          } else {
            this.$set(this.descriptionBOJson[item.key], key, key == 'keywords' ? [] : '');
          }
        })
        this.descriptionTab.forEach(text => {
          if (langCont[0]) {
            this.$set(this.descriptionBOJson[item.key], text.key, langCont[0][text.key] || '');
          } else {
            this.$set(this.descriptionBOJson[item.key], text.key, '');
          }
        })
      })
    },
    // 语言切换时更新数据多文本数据
    langTabsSwitch() {
      if (this.descActiveTab == 'textDescription') return;
      this.descriptionBOJson[this.oldActiveLang][this.oldActiveDesc] = this.editor.getContent();
      this.$nextTick(() => {
        const content = this.descriptionBOJson[this.langActiveTab][this.descActiveTab];
        this.editor.setContent(content);
        this.oldActiveLang = this.langActiveTab;
      })
    },
    // 描述类型切换时更新数据多文本数据
    descTabsSwitch() {
      if (this.descActiveTab == 'textDescription') return;
      this.descriptionBOJson[this.oldActiveLang][this.oldActiveDesc] = this.editor.getContent();
      this.$nextTick(() => {
        const content = this.descriptionBOJson[this.langActiveTab][this.descActiveTab];
        this.editor.setContent(content);
        this.oldActiveDesc = this.descActiveTab;
      })
    },
    // 数据转换
    textTranform(productInfo) {
      return new Promise((resolve) => {
        this.descriptionBOJson[this.oldActiveLang][this.oldActiveDesc] = this.editor.getContent();
        this.$nextTick(() => {
          let newData = Object.values(JSON.parse(JSON.stringify(this.descriptionBOJson)));
          const keys = Object.keys(this.descriptionBOJson);
          newData.forEach((item, index) => {
            !item.productId && (item.productId = productInfo.productId || '');
            !item.language && (item.language = keys[index]);
            item.keywords = item.keywords.map(val => {
              return val.attrVal;
            }).join(',');
          })
          resolve(newData);
        })
      })
    },
    // skc 验证
    validateFormSkc(value) {
      let reg = /^[0-9]*$/g;
      if (!reg.test(value)) {
        return false;
      }
      return true;
    },
    getCommodityDeveloper () {
      return new Promise((resolve) => {
        // commodityDeveloper（即商品开发员）
        this.axios.get(api.get_queryByBusinessRoleType + 'commodityDeveloper').then((res) => {
          if (res && res.data && res.data.code === 0) {
            // this.businessRoleTypeList = res.data.datas;
            this.businessRoleTypeList = res.data.datas.filter(k => {
              return k.status === '1'
            })
          }
        }).finally(() => {
          resolve({ state: 'finally' });
        })
      })
    },
    // 处理树节点
    treeNormalizer(node) {
      return {
        id: node.productCategoryId,
        label: node.title,
        children: node.children
      }
    },
    // 所属分类改变
    getTreeData(treeId) { // 选择分类时把id赋值给商品模型分类ID
      let productCategory = this.treeSelectCategoryJson[treeId] || {};
      if (['productCategoryId1'].includes(treeId)) {
        this.$nextTick(() => {
          this.$Message.error('“全部” 选项不可选中');
          this.treeSelectCategoryValue = this.productInfo.productCategoryId
        })
        return
      }
      if (['productCategoryId1', 'noCategory'].includes(treeId)) {
        delete productCategory.productCategoryId
      }
      const hand = {
        findExistValue: () => {
          if (!productCategory || this.productInfo.productCategoryId != productCategory.productCategoryId) {
            // 当 productId 为空是，切换属性不提示 !this.categoryChange
            if (!this.productInfo.productId || !productCategory.productCategoryId) {
              hand.changeData();
              return;
            }
            this.axios.post(api.categoryAttributeAgreement, {
              productIdList: [this.productInfo.productId],
              newCategoryId: productCategory.productCategoryId,
              selectAll: 0,
            }).then(res => {
              if (res.data.code == 0) {
                if (!this.$common.isEmpty(res.data.datas)) {
                  this.$Modal.confirm({
                    title: '提示',
                    width: 600,
                    content: `<p>修改分类前后绑定属性不同，需要重新录入商品属性资料，是否确认修改所属分类？</p>`,
                    onOk: () => {
                      hand.changeData();
                    },
                    onCancel: () => {
                      this.initCategoryTree(this.productInfo.productCategoryId);
                      this.initGetTreeData = true
                    }
                  });
                } else {
                  hand.changeData(false);
                }
              } else {
                hand.changeData();
              }
            })
          }
        },
        changeData: (attrChange = true) => {
          if (productCategory && productCategory.productCategoryId) {
            this.productInfo.productCategoryId = productCategory.productCategoryId;
            this.productInfo.cnHsName = productCategory.cnHsName;
            this.productInfo.enHsName = productCategory.enHsName;
            this.productInfo.hsCode = productCategory.hsCode;
            // 商品属性组件内部监听 productCategoryId 变化，自动重新加载属性数据
          } else {
            this.productInfo.productCategoryId = null;
            this.productInfo.cnHsName = null;
            this.productInfo.enHsName = null;
            this.productInfo.hsCode = null;
          }
          this.oldAttrChange = attrChange;
          this.getSizeList();
        }
      };
      if (!this.initGetTreeData) {
        this.initGetTreeData = false
        hand.findExistValue();
      }
    },
    getYmsTreeData(productCategory) {
      if (productCategory && productCategory.ymsProductCategoryId) {
        this.productInfo.ymsProductCategoryId = productCategory.ymsProductCategoryId;
        this.classifyTalg = 'change';
        this.getTemplateData(productCategory.ymsProductCategoryId);
      } else {
        this.productInfo.ymsProductCategoryId = null;
      }
    },
    validateCustomFields(newProduct) { // 校验货品属性
      let error = false;
      this.validateCol = {
        isWeight: [],
        isLength: [],
        isWidth: [],
        isHeight: [],
        isSuggestPrice: []
      }
      const reg = /^([1-9]\d*(\.\d{1,2})?|([0](\.([0][1-9]|[1-9]\d{0,1}))))$/;
      if (!newProduct.productGoodsList) return !error;
      for (let i = 0; i < newProduct.productGoodsList.length; i++) {
        let productGoods = newProduct.productGoodsList[i];
        !reg.test(productGoods.weight) && this.validateCol.isWeight.push(i);
        !reg.test(productGoods.length) && this.validateCol.isLength.push(i)
        !reg.test(productGoods.width) && this.validateCol.isWidth.push(i);
        !reg.test(productGoods.height) && this.validateCol.isHeight.push(i)
        // !reg.test(productGoods.suggestPrice) && this.validateCol.isSuggestPrice.push(i);
        if (productGoods.productGoodsSpecifications) {
          productGoods.productGoodsSpecifications.forEach((productGoodsSpecification, index) => {
            if (productGoodsSpecification.value === null || productGoodsSpecification.value === '') {
              error = true;
            }
          });
          if (error) {
            this.activeTab = 'baseInfo';
            break;
          }
        }
      }
      return !error;
    },
    // 编辑图片模式：图片信息校验（当前暂无强制规则，后续图片校验规则统一在此扩展，如通用语言图片至少一张）
    validatePictureInfo() {
      return true;
    },
    // 保存前校验
    async beforeSave(value) {
      this.productInfo.operationType = value ? 1 : 0;
      // 编辑图片模式：只校验图片信息并保存，其余校验（质检/基础资料/多属性/属性等）全部跳过
      if (this.isEditPicture) {
        this.showSpin('处理中...');
        this.waitingOk = true;
        if (!this.validatePictureInfo()) {
          this.waitingOk = false;
          this.hideSpin();
          return;
        }
        this.saveInfo().then(() => {
          this.waitingOk = false;
          this.hideSpin();
        }).catch(() => {
          this.waitingOk = false;
          this.hideSpin();
        });
        return;
      }
      const hand = {
        productInfoValid: (newProduct) => {
          this.showSpin('处理中...');
          this.waitingOk = true;
          this.$refs['productInfo'].validate((valid) => {
            let isPass = false;
            isPass = this.validateCustomFields(newProduct);

            if (valid && isPass) {
              const keys = Object.keys(this.validateCol);
              const nowKey = keys.find(key => {
                return this.validateCol[key].length > 0;
              })
              if (this.$common.isEmpty(nowKey)) {
                hand.attributeValidate();
                return;
              }
              const getDemo = document.querySelector(`.${nowKey}-${this.validateCol[nowKey][0]}`);
              if (getDemo) {
                this.locationErrorInput('multiattribute', '多属性资料列表中的价格，重量，尺寸需大于 0 并且最多2位小数的数字');
                this.$nextTick(() => {
                  getDemo.querySelector('input').focus();
                })
              }
              this.waitingOk = false;
              this.hideSpin();
            } else {
              this.locationErrorInput('baseInfo', '基础资料中存在必填项未填写或格式有误，请确保正确填写');
              this.waitingOk = false;
              this.hideSpin();
            }
          });
        },
        attributeValidate: () => {
          const productAttributeRef = this.$refs.productAttributeRef;
          if (!productAttributeRef) {
            hand.productInfo();
            return;
          }
          productAttributeRef.validate().then(attrvalid => {
            if (!attrvalid) {
              this.waitingOk = false;
              this.hideSpin();
              this.locationErrorInput('baseInfo', '商品属性信息存在必填项未填写');
              document.querySelectorAll('.editProductDome .ivu-sliderModal-body')[0].scrollTop = 0;
              return;
            }
            hand.productInfo();
          });
        },
        productInfo: () => {
          new Promise((resolve, reject) => {
            // this.saveInfo(resolve);
            this.saveInfo(resolve).then(() => {
              if (newType) {
                this.newSaveQuality(formData).finally(() => {
                  this.waitingOk = false;
                  this.hideSpin();
                });
              }else {
                this.waitingOk = false;
                this.hideSpin();
              }
            }).catch(() => {
              this.waitingOk = false;
              this.hideSpin();
            });
          }).catch(() => {
            this.waitingOk = false;
            this.hideSpin();
          });
        },
        qualityValidate: () => {
          return new Promise((resolve, reject) => {
            const qualityDemo = this.$refs.qualityInspection;
            // console.log('qualityDemo', qualityDemo)
            let [qualityVal, getFormData] = [null, null];
            if (qualityDemo) {
              getFormData = qualityDemo.getFormData();
              if (!getFormData.newType) {
                qualityVal = getFormData.data;
              }
              qualityDemo.validate((valid) => {
                if (!valid) {
                  reject("质检标准验证失败");
                }else {
                  resolve({ qualityVal , newType: getFormData.newType, formData: getFormData.data });
                }
              })
            }else {
              resolve({});
            }
          });
        },
      };
      const { qualityVal, newType, formData } = await hand.qualityValidate();
      this.productInfo.qualityClassificationId = qualityVal || null;
      this.$nextTick(() => {
        hand.productInfoValid(this.productInfo);
      })
    },
    // 质检标准新逻辑保存
    newSaveQuality (formParams) {
      return new Promise((resolve) => {
        this.axios.post(api.batchUpdateQualityTemplate, formParams).then(res => {
          if (res.data && res.data.code == 0) {
            return resolve({ state: true });
          }
          resolve({ state: false });
        }).catch(() => {
          resolve({ state: false });
        })
      })
    },
    // 定位到验证不通过的地方
    locationErrorInput(errorTag, errTxt, type = false) {
      this.pageEditTag = errorTag;
      if (type) return;
      if (!this.$common.isEmpty(errTxt)) {
        this.$Message.error(errTxt);
      }
      setTimeout(() => {
        this.$nextTick(() => {
          this.hideSpin();
          this.waitingOk = false;
          // 定位到第一个验证不通过项位置
          this.$nextTick(() => {
            let errorDemo = document.querySelector(`.tag-content-${errorTag} .ivu-form-item-error`);
            if (!this.$common.isEmpty(errorDemo)) {
              const textDemo = errorDemo.querySelector('input[type="text"]');
              errorDemo = this.$common.isEmpty(textDemo) ? errorDemo.querySelector('textarea') : textDemo;
              if (!this.$common.isEmpty(errorDemo)) {
                errorDemo.focus();
              }
            }
          })
        })
      }, 500)
    },
    // 保存
    async saveInfo () {
      return new Promise(async (resolve, reject) => {
        // 深拷贝，防止修改到表单值
        let newProductInfo = this.$common.copy(this.productInfo);
        // 处理多语言图片数据
        newProductInfo.multiLangImages = this.multiLangImageData.map(m => {
          return {
            language: m.language,
            productImages: (() => {
              let updateImages = [];
              (m.images || []).forEach(i => {
                if (i.setName == '通用' || i.addCommon) {
                  updateImages.push(i.path);
                }
              });
              return updateImages;
            })()
          };
        });
        delete newProductInfo.multiLangImageList; // 删除多语言图片列表(保存时候不需要)
        delete newProductInfo.productImageList; // 删除图片列表(保存时候不需要)
        delete newProductInfo.productImages; // 删除图片列表(保存时候不需要)
        newProductInfo.newSupplierCheck = newProductInfo.newSupplierCheck ? 1 : 0;
        newProductInfo.basicSpecificationVerification = newProductInfo.basicSpecificationVerification ? 1 : 0;
        if (newProductInfo.productGoodsList.length === 1 &&
          (!newProductInfo.productGoodsList[0].productGoodsSpecifications || newProductInfo.productGoodsList[0].productGoodsSpecifications.length == 0)
        ) {
          newProductInfo.productGoodsList[0].sku = newProductInfo.spu;
          newProductInfo.productGoodsList[0].productGoodsAcceptableTc = this.productTypeListValue.join(',');
          delete newProductInfo.productGoodsList[0].productTypeListValue;
        }
        // 当不是服装分类类型时，braidType 要设置为空
        if (!this.isClothingType) {
          newProductInfo.braidType = null;
        }
        if (!this.$common.isEmpty(newProductInfo.washedLabelWordFile)) {
          newProductInfo.washedLabelWordPath = newProductInfo.washedLabelWordFile.fileUrl;
          newProductInfo.washedLabelWordName = newProductInfo.washedLabelWordFile.fileName;
          delete newProductInfo.washedLabelWordFile;
        } else {
          newProductInfo.washedLabelWordPath = '';
          newProductInfo.washedLabelWordName = '';
        }
        // 组装信息
        if (newProductInfo.productGoodsList) {
          newProductInfo.productGoodsList.forEach((n, i) => {
            // productGoodsImages 只需要 setName 为 通用的数据
            n.productGoodsImages = (n.productGoodsImages || []).filter(f => {
              return f.language == 'common' && f.setName == '通用';
            }).map(m => m.path);
            if (n.upc === '') {
              n.upc = null;
            }
            if (n.isAssemble) { // 先判断是否是组装产品
              n.isAssemble = 1;
              const assembles = n.productGoodsAssembles || [];
              if (assembles.length > 0) {
                n.productGoodsAssembles = assembles.map(item => ({
                  materialProductGoodsId: item.materialProductGoodsId || item.productGoodsId,
                  quantity: item.quantity
                }));
              } else {
                n.isAssemble = 0;
                n.productGoodsAssembles = [];
              }
            } else {
              n.isAssemble = 0;
              n.productGoodsAssembles = [];
            }
            n.productGoodsAcceptableTc = n.productTypeListValue && n.productTypeListValue.length ? n.productTypeListValue.join(',') : null;
            delete n.productTypeListValue;
          });
        }
        newProductInfo.descriptionBOList = await this.textTranform(newProductInfo);
        // 是供应商用户才做校验（编辑图片模式只保存图片信息，跳过该校验）
        if (this.isSupplierTalg) {
          if (!this.isEditPicture && newProductInfo.ymsProductCategoryId === null) {
            this.locationErrorInput('baseInfo', '请选择云卖分类！');
            this.waitingOk = false;
            this.hideSpin();
            return false;
          }
          // 处理尺码表的参数
          if (this.classifyTalg === 'edit') {
            if (this.sizeChartdata.length > 0 && Object.keys(this.sizeJsonData).length > 0) {
              let insetProductSizeBoList = [];
              let data = this.sizeJsonData.productSizePartsBos;
              this.sizeChartdata.forEach((item) => {
                let obj = {
                  sizeCode: '',
                  ukSize: '',
                  euSize: '',
                  usSize: '',
                  sizeDetailBos: []
                };
                data.forEach((ele, index) => {
                  obj.sizeDetailBos.push({
                    partsName: item['partsName_' + index],
                    unitName: item['unitName_' + index],
                    unitValue: item['unitValue_' + index]
                  });
                });
                obj.sizeCode = item.sizeCode;
                obj.ukSize = item.ukSize;
                obj.euSize = item.euSize;
                obj.usSize = item.usSize;
                insetProductSizeBoList.push(obj);
              });
              newProductInfo.insetProductSizeBoList = insetProductSizeBoList;
              newProductInfo.sizeJson = JSON.stringify(this.sizeJsonData);
              if (newProductInfo.insetProductSizeBoList.length > 0) {
                let list = newProductInfo.insetProductSizeBoList;

                let valid = false;
                let obj = {};

                for (let i = 0; i < list.length; i++) {
                  for (let key in list[i]) {
                    if (key !== 'sizeDetailBos') {
                      if (!obj[key]) {
                        obj[key] = [list[i][key]];
                      }
                      obj[key].push(list[i][key]);
                    }
                  }
                  for (let j = 0; j < list[i].sizeDetailBos.length; j++) {
                    let t = list[i].sizeDetailBos[j];
                    if (!obj[t.partsName]) {
                      obj[t.partsName] = [];
                    }
                    obj[t.partsName].push(t.unitValue);
                  }
                }
                for (let key in obj) {
                  if (obj[key].some(k => k && k !== '0') && obj[key].some(k => !k || Number(k) === 0)) {
                    valid = true;
                  }
                }
                if (!this.isEditPicture && valid) {
                  this.$Message.error('尺码表单独规格必须填写完整！');
                  this.waitingOk = false;
                  this.hideSpin();
                  return false;
                }
              }
            } else {
              delete newProductInfo.insetProductSizeBoList;
            }
          } else if (this.classifyTalg === 'change') {
            if (this.sizeChartdata.length > 0 && Object.keys(this.sizeJsonData).length > 0) {
              let insetProductSizeBoList = [];
              let data = this.sizeJsonData.productSizePartsBos;
              this.sizeChartdata.forEach(item => {
                let obj = {
                  sizeCode: '',
                  ukSize: '',
                  euSize: '',
                  usSize: '',
                  sizeDetailBos: []
                };
                data.forEach(ele => {
                  obj.sizeDetailBos.push({
                    partsName: item[ele.ymsProductSizePartsId + '_partName'],
                    unitName: item[ele.ymsProductSizePartsId + '_defaultUnitName'],
                    unitValue: item[ele.ymsProductSizePartsId + '_defaultValue']
                  });
                });
                obj.sizeCode = item.size;
                obj.ukSize = item.ukSize;
                obj.euSize = item.euSize;
                obj.usSize = item.usSize;
                insetProductSizeBoList.push(obj);
              });
              newProductInfo.insetProductSizeBoList = insetProductSizeBoList;
              newProductInfo.sizeJson = JSON.stringify(this.sizeJsonData);
              if (newProductInfo.insetProductSizeBoList.length > 0) {
                let list = newProductInfo.insetProductSizeBoList;
                let valid = false;
                let obj = {};
                for (let i = 0; i < list.length; i++) {
                  for (let key in list[i]) {
                    if (key !== 'sizeDetailBos') {
                      if (!obj[key]) {
                        obj[key] = [list[i][key]];
                      }
                      obj[key].push(list[i][key]);
                    }
                  }
                  for (let j = 0; j < list[i].sizeDetailBos.length; j++) {
                    let t = list[i].sizeDetailBos[j];
                    if (!obj[t.partsName]) {
                      obj[t.partsName] = [];
                    }
                    obj[t.partsName].push(t.unitValue);
                  }
                }
                for (let key in obj) {
                  if (obj[key].some(k => k && k !== '0') && obj[key].some(k => !k || Number(k) === 0)) {
                    valid = true;
                  }
                }
                if (!this.isEditPicture && valid) {
                  this.$Message.error('尺码表单独规格必须填写完整!');
                  this.waitingOk = false;
                  this.hideSpin();
                  return false;
                }
              }
            } else {
              delete newProductInfo.insetProductSizeBoList;
            }
          }
        }
        if (newProductInfo.type == 2) {
          newProductInfo.productGoodsList.forEach(k => {
            (k.productGoodsSpecifications || []).forEach(j => {
              if (this.$common.isEmpty(j.value)) {
                this.$set(j, 'value', '');
              }
              if (j.name == 'Color' && !this.isOldData) {
                if (this.getColorAll.includes(j.value)) {
                  this.colorList.forEach(m => {
                    if (j.value == m.color) {
                      this.$set(j, 'skcCode', m.skcCode);
                      this.$set(j, 'typeValueId', m.colorId);
                    }
                  })
                } else if (this.specificationsObj[`${j.name}${j.value}`]) {
                  this.$set(j, 'typeValueId', this.specificationsObj[`${j.name}${j.value}`].typeValueId);
                }
                j.type = 1;
              } else if (j.name == 'Size' && !this.isOldData) {
                if (this.getSizeVal.includes(j.value)) {
                  this.sizeList.forEach(m => {
                    if (!m.disabled) {
                      m.children.forEach(n => {
                        if (j.value == n.size) {
                          this.$set(j, 'sizeCode', n.sizeCode);
                          this.$set(j, 'typeValueId', n.sizeId);
                        }
                      })
                    }
                  })
                } else if (this.specificationsObj[`${j.name}${j.value}`]) {
                  this.$set(j, 'typeValueId', this.specificationsObj[`${j.name}${j.value}`].typeValueId);
                }
                j.type = 2;
              } else {
                j.type = 3;
              }
            })
          })
        }

        let awaitRes = [];
        // 获取物料表单信息
        if (this.$refs.materialRefDemo) {
          awaitRes.push(() => {
            return new Promise((resolve, reject) => {
              this.$refs.materialRefDemo.getFormData(this.isEditPicture ? 0 : 1).then(res => {
                if (!res.success) return reject(res);
                newProductInfo.productGoodsMaterialInfoVOList = res.data;
                newProductInfo.updateProductMaterialInfo = 1;
                resolve(res);
              }).catch((err) => {
                console.error(err);
                reject(err);
              })
            })
          })
        }
        // 获取其他费用
        if (this.$refs.refLaPaFeeType) {
          awaitRes.push(() => {
            return new Promise((resolve, reject) => {
              this.$refs.refLaPaFeeType.getFormData(this.isEditPicture ? 0 : 1).then(res => {
                if (!res.success) return reject(res);
                newProductInfo.productFeeTypeList = res.data;
                resolve(res);
              }).catch((err) => {
                console.error(err);
                reject(err);
              })
            })
          })
        }
        // 获取其他费用
        if (this.$refs.processRequireInstructionsRef) {
          awaitRes.push(() => {
            return new Promise((resolve, reject) => {
              this.$refs.processRequireInstructionsRef.getFormData(this.isEditPicture ? 0 : 1).then(res => {
                if (!res.success) return reject(res);
                newProductInfo.productProcessRequireList = res.data;
                resolve(res);
              }).catch((err) => {
                console.error(err);
                reject(err);
              })
            })
          })
        }
        this.$common.promiseAll(awaitRes).then(() => {
          if (newProductInfo.productId) {
            resolve(this.axios.put(api.productInfo_update, newProductInfo).then(response => {
              if (response.data.code === 0) {
                this.$Message.success('更新成功');
                // 编辑图片模式：只保存图片信息，跳过属性/平台类目保存，不询问是否同步Listing，直接关闭并刷新列表
                if (this.isEditPicture) {
                  this.turnBack();
                  this.turnUpdate();
                  this.$parent.$parent.pageParamsStatus = true;
                  return;
                }
                // 等经典属性、多平台商品属性、平台类目都保存完后，再弹出同步确认框
                const attrRef = this.$refs.productAttributeRef;
                const ppcRef = this.$refs.productPlatformCategoryRef;
                const savePromises = [];
                if (attrRef) {
                  savePromises.push(attrRef.saveClassicAttribute());
                  savePromises.push(attrRef.savePlatformAttribute());
                }
                if (ppcRef) {
                  savePromises.push(ppcRef.saveData());
                }
                Promise.all(savePromises).then(() => {
                  this.synchronousRemind(newProductInfo);
                });
              }
            }));
          } else {
            resolve(this.axios.post(api.productInfo_insert, newProductInfo).then(response => {
              if (response.data.code === 0) {
                const savedProductId = response.data.datas.productId || '';
                this.$Message.success('新增成功');
                // 等经典属性、多平台商品属性、平台类目都保存完后，再弹出同步确认框
                const attrRef = this.$refs.productAttributeRef;
                const ppcRef = this.$refs.productPlatformCategoryRef;
                const savePromises = [];
                if (attrRef) {
                  savePromises.push(attrRef.saveClassicAttribute(savedProductId));
                  savePromises.push(attrRef.savePlatformAttribute(savedProductId));
                }
                if (ppcRef) {
                  savePromises.push(ppcRef.saveData());
                }
                Promise.all(savePromises).then(() => {
                  this.synchronousRemind({ ...newProductInfo, productId: savedProductId });
                });
              }
            }));
          }
        }).catch(err => {
          this.locationErrorInput('productionInfo');
          console.error(err);
          reject(err);
          this.hideSpin();
          this.waitingOk = false;
        })
      });
    },
    del() {
      this.$Modal.confirm({
        title: '温馨提示',
        okText: '确定',
        content: '是否删除该SPU？',
        onOk: () => {
          let temp = this.firstProductInfo.productGoodsList.map(k => {
            return k.productGoodsId
          })
          let reqParams = {
            productGoodsIds: temp
          }
          this.axios.post(api.productGoods_batchDelete, reqParams).then((res) => {
            if (res.data.code === 0) {
              this.$Message.success(res.data.message);
              this.turnBack();
              this.turnUpdate();
            } else {
              this.$Message.error(res.data.message)
            }
          });
        }
      });
    },
    // 打开选择水洗唛word文件弹窗
    opentCheckFile() {
      if (!this.$refs.washedUploadRef || !this.$refs.washedUploadRef.$el) return;
      const demo = this.$refs.washedUploadRef.$el.querySelector('.ivu-upload-select');
      if (!demo) return;
      demo.click();
    },
    // 水洗唛PDF文件上传
    washedUploadBefore(file) {
      if (this.isWashedUploadLoading || this.isDisabled) return false;
      if (['application/pdf', 'image/jpg', 'image/png', 'image/jpeg'].includes(file.type)) {
        this.isWashedUploadLoading = true;
        let newForm = new FormData(); // 创建form对象
        newForm.append('files', file);
        const uploadUrl = `${this.uploadFilesUrl}&random=${(Math.random()).toString().substring(2, 5) + (new Date().getTime()).toString()}`;
        this.axios.post(uploadUrl, newForm).then(res => {
          if (!res.data || res.data.code != 0) {
            this.isWashedUploadLoading = false;
            return;
          }
          this.$set(this.productInfo, 'washedLabelPdfPath', res.data.datas[0]);
          this.$set(this.productInfo, 'washedLabelPdfName', file.name);
          if (['application/pdf'].includes(file.type)) {
            this.$common.getPdfRes({
              pdfUrl: `./filenode/s${res.data.datas[0]}`,
              pageNumber: 1,
              scale: 10
            }).then(img => {
              this.pdfFirstImgPreview = img;
            }).finally(() => {
              this.isWashedUploadLoading = false;
            })
          } else {
            this.pdfFirstImgPreview = `./filenode/s${res.data.datas[0]}`;
            this.isWashedUploadLoading = false;
          }
        }).catch(() => {
          this.isWashedUploadLoading = false;
        })
        return false;
      }
      this.$Message.error('文件格式不对，请上传 PDF 文件或 PNG、JPG 类型的图片');
      return false;
    },
    // 移除水洗唛PDF文件
    removeWashedPdf() {
      this.$Modal.confirm({
        width: 500,
        title: '操作提示',
        content: '<div>确认删除水洗唛文件？</div><div style="font-size:12px;color:#f60;">注意：删除后需要保存才生效</div>',
        onOk: () => {
          this.$set(this.productInfo, 'washedLabelPdfPath', null);
          this.$set(this.productInfo, 'washedLabelPdfName', null);
        },
        onCancel: () => { }
      })
    },
    // 水洗唛PDF文件预览 productInfo.washedLabelPdfPath
    previewWashedPdf (viewUrl) {
      if (this.$common.isEmpty(viewUrl)) return;
      const suffix = viewUrl.substring(viewUrl.lastIndexOf('.'), viewUrl.length);
      if (suffix.toLocaleLowerCase() == '.pdf') {
        this.axios.get(`./filenode/s${viewUrl}`, { responseType: 'blob' }).then(res => {
          this.$common.blobToBase64(res.data || res.resData).then(data => {
            const fileBold = this.$common.base64ToBlob(data, 'application/pdf');
            this.$common.previewFile(fileBold);
          })
        })
      } else {
        window.open(`./filenode/s${viewUrl}`);
      }
    },
    // 图片预览
    previewImg(imgUrl) {
      window.open(imgUrl);
    },
    // 移除尺码图
    removePlanImg() {
      if (this.$common.isEmpty(this.productInfo)) return;
      const imgUrl = this.dimensionPlan.substring(this.filenodeViewTargetUrl.length);
      // 使用 map 生成新数组，触发 Vue 响应式追踪
      this.multiLangImageData = this.multiLangImageData.map(item => {
        if (item.language === 'common') {
          return {
            ...item,
            images: item.images.filter(img => img.path !== imgUrl)
          };
        }
        return { ...item };
      });

      if (!this.$common.isEmpty(this.productInfo.productImageTypeList)) {
        this.productInfo.productImageTypeList = [];
      }
    },
    // 验证外包装
    validateOutPack(rule, value, callback) {
      if (this.isDisabled) return callback();
      if (!this.$common.isEmpty(value) && value.trim().length > 200) {
        return callback(new Error('输入字符超出规定，最多200字符'));
      }
      return callback();
    },
    turnBack() { // 关闭
      this.initFinished = false;
      Object.keys(this.pageTagView).forEach(key => {
        this.pageTagView[key] = false;
      });
      this.$refs['productInfo'] && this.$refs['productInfo'].resetFields();
      this.$refs['productAttributeRef'] && this.$refs['productAttributeRef'].resetAttribute();
      this.locationErrorInput('baseInfo', '', true);
      this.productInfo = this.deepCopy(this.productInfoPrototype);
      this.oldAttrChange = false;
      this.skuData = [];
      this.skuPropertyList = [];
      this.classifyTalg = 'edit';
      this.$emit('goBack');
      this.$emit('update:editProductModal', false)
    },
    turnUpdate() {
      this.$emit('updateList');
    },
    // 刷新列表
    refreshList (res) {
      this.$emit('refreshList', res);
      this.getGpsrInfo(this.pageProductGoodsId);
    },
    initProductInfo(productInfo) { // 初始化商品信息
      return new Promise((resolve, reject) => {
        this.productInfo = {
          ...productInfo,
          checkType: this.$common.isEmpty(productInfo.checkType) ? '0' : productInfo.checkType.toString(),
          descriptionBOList: productInfo.descriptionBOList || [],
          productImages: [],
          productGoodsList: [],
          deliveryInterval: productInfo.deliveryInterval || 1
        };
        const includeKey = ['materialCnDesc', 'materialEnDesc', 'usageCnDesc', 'usageEnDesc'];
        includeKey.forEach(key => {
          this.$set(this.productInfo, key, productInfo[key] || '');
        });
        // 初始化 商品描述数据
        this.textInit(productInfo.descriptionBOList || [], productInfo.productId);
        // 处理质检数据
        if (productInfo.productQualityMeasureList && productInfo.productQualityMeasureList.length > 0) {
          let pos = [];
          productInfo.productQualityMeasureList.forEach((n, i) => {
            if (i === 0) {
              pos.push({
                measureName: n.measureName,
                measureVal: [
                  {
                    itemName: n.itemName,
                    itemValue: n.itemValue
                  }
                ]
              });
            } else {
              pos.forEach((m, t) => {
                if (m.measureName === n.measureName) { // 类目一致
                  m.measureVal.push({
                    itemName: n.itemName,
                    itemValue: n.itemValue
                  });
                } else if (t === pos.length - 1 && m.measureName !== n.measureName) {
                  pos.push({
                    measureName: n.measureName,
                    measureVal: [
                      {
                        itemName: n.itemName,
                        itemValue: n.itemValue
                      }
                    ]
                  });
                }
              });
            }
          });
          this.categoryList = pos;
        } else {
          this.categoryList = [];
        }
        // let imageSetIdObj = {};
        // if (!this.$common.isEmpty(productInfo.productGoodsList)) {
        //   (productInfo.productGoodsList.imageSetList || []).forEach((imageSet) => {
        //     imageSetIdObj[imageSet.productGoodsImageSetId] = imageSet;
        //   });
        // }
        // 处理多语言图片数据
        if (!this.$common.isEmpty(productInfo.multiLangImageList)) {
          let selfPic = [];
          // let productPath = [];
          let isPush = this.$common.isEmpty(this.productInfo.productImageTypeList);
          let imageTypeList = {};
          (productInfo.multiLangImageList || []).forEach((item) => {
            if (!this.$common.isEmpty(item.images)) {
              item.images.forEach((productImage) => {
                productImage.addCommon = true;
                productImage.setName = '通用';
              });
            }
            if (!this.$common.isEmpty(imageTypeList) && item.language === 'common') {
              imageTypeList = item;
            }
          });
          (imageTypeList.images || []).forEach((productImage) => {
            if ([2, 3, 4, '2', '3', '4'].includes(productImage.imageType) && isPush) {
              selfPic.push({
                path: productImage.path,
                imageType: productImage.imageType
              });
            }
          });
          this.multiLangImageData = productInfo.multiLangImageList;
          if (isPush) {
            this.$set(this.productInfo, 'productImageTypeList', selfPic);
          }
        }
        this.removeTableColumn();
        resolve();
      })
    },
    // 初始化货品信息（包括组装信息、规格属性、图片信息）
    initProductGoods(productGoodsList) {
      let self = this;
      productGoodsList.forEach((productGoods, index) => {
        let newProductGoods = {
          ...(this.$common.copy(productGoods)),
          productGoodsTags: [],
          // productGoodsImages: productGoods.productGoodsImages || [],
          isAssemble: productGoods.isAssemble === 1, // 是否组装
          editStatus: false, // 是否重新编辑
          productTypeListValue: (productGoods.productGoodsAcceptableTypes || []).map(i => {
            return i.typeCode;
          })
        };
        let imageSetIdObj = {};
        // imageSetList 图套列表
        (newProductGoods.imageSetList || []).forEach((imageSet) => {
          imageSetIdObj[imageSet.productGoodsImageSetId] = imageSet;
        });
        // productGoodsImages 要去 imageSetList 匹配上 setName
        (newProductGoods.productGoodsImages || []).forEach((item) => {
          if (!this.$common.isEmpty(imageSetIdObj[item.imageSetId])) {
            item.setName = imageSetIdObj[item.imageSetId].setName;
          }
        });
        // 组装信息
        if (productGoods.productGoodsAssembles) {
          let pos = [];
          let pic = null;
          productGoods.productGoodsAssembles.forEach((m, t) => {
            pic = m.productGoodsImages ? m.productGoodsImages[0].path : null;
            pos.push({
              productGoodsId: m.materialProductGoodsId,
              sku: m.sku,
              skc: m.skc,
              name: m.cnName,
              value: m.productGoodsSpecifications,
              quantity: m.quantity,
              pictureUrl: pic
            });
          });
          self.addAssembleData = pos;
          self.addData = pos;
        }
        let productGoodsTagNames = [];
        // let productGoodsImagePaths = [];
        let productGoodsTags = productGoods.productGoodsTags;
        // let productGoodsImages = productGoods.productGoodsImages;
        if (productGoodsTags) {
          productGoodsTags.forEach((productGoodsTag, i) => {
            productGoodsTagNames.push(productGoodsTag.tagName);
            if (self.customProductTagList.indexOf(productGoodsTag.tagName) === -1) {
              self.customProductTagList.push(productGoodsTag.tagName);
            }
          });
        }
        newProductGoods.productGoodsTags = productGoodsTagNames;
        // 初始化规格属性
        if (productGoods.productGoodsSpecifications) {
          let skuList = this.$common.copy(self.skuPropertyList);
          productGoods.productGoodsSpecifications.forEach((productGoodsSpecification, i) => {
            this.$set(this.specificationsObj, `${productGoodsSpecification.name}${productGoodsSpecification.value}`, productGoodsSpecification);
            if (!skuList[i]) {
              skuList[i] = {
                name: productGoodsSpecification.name,
                invalid: false,
                values: [productGoodsSpecification.value],
                selected: true,
                isEdit: true
              };
            } else if (skuList[i].values.indexOf(productGoodsSpecification.value) === -1) {
              skuList[i].values.push(productGoodsSpecification.value);
              skuList[i].selected = true;
            }
          });
          self.skuPropertyList = skuList;
        }
        self.productInfo.productGoodsList.push(newProductGoods);
      });
      if (self.productInfo.productGoodsList.length === 1 && self.productInfo.productGoodsList[0].productGoodsAcceptableTypes) {
        self.productTypeListValue = self.productInfo.productGoodsList[0].productGoodsAcceptableTypes.map(i => {
          return i.typeCode;
        });
      }
      self.skuData = self.deepCopy(self.productInfo.productGoodsList);
    },
    getProductCategoryTree(productCategoryListData, parentId, currentProductCategoryId) { // 组装商品分类树
      // let self = this;
      let tree = [];
      let children;
      if (!productCategoryListData) {
        return [];
      }
      productCategoryListData.forEach((n, i) => {
        if (n.parentId === parentId) {
          n.title = n.cnName;
          n.expand = true;
          if (n.productCategoryId === currentProductCategoryId) {
            this.treeSelectCategoryValue = currentProductCategoryId;
          } else {
            n.selected = false;
          }
          children = this.getProductCategoryTree(productCategoryListData, n.productCategoryId, currentProductCategoryId);
          if (children.length > 0) {
            n.children = children;
          }
          this.$set(this.treeSelectCategoryJson, n.productCategoryId, n);
          tree.push(n);
        }
      });
      return tree;
    },
    initCategoryTree(currentProductCategoryId) { // 初始化分类树
      let productCategoryTree = this.getProductCategoryTree(this.$common.copy(this.productCategoryListData), null, currentProductCategoryId);
      let noCategory = {
        title: '未分类',
        productCategoryId: 'noCategory'
      };
      this.treeSelectCategoryJson['noCategory'] = JSON.parse(JSON.stringify(noCategory))
      if (currentProductCategoryId === null || currentProductCategoryId == '') {
        this.treeSelectCategoryValue = 'noCategory'
        noCategory.selected = true;
      }
      productCategoryTree.unshift(noCategory);
      this.$set(this.productCategoryTree[0], 'children', productCategoryTree);
      this.treeSelectCategoryJson['productCategoryId1'] = JSON.parse(JSON.stringify(this.productCategoryTree[0]))
      this.$nextTick(() => {
        this.initGetTreeData = false;
        this.categoryChange = true;
        this.disabledTreeItem();
      })
    },
    initYmsCategoryTree(ymsProductCategoryId) {
      if (this.originalCategoryData) {
        let obj = this.originalCategoryData.filter(i => i.ymsProductCategoryId === ymsProductCategoryId);
        this.$refs.productCategoryTree1.treeSelectGetValue(obj);
      }
    },
    /** 编辑SKU图片 */
    editSkuImage(index) {
      this.$refs.skuImageSetModalRef.editSkuImage(index);
    },
    editDistribution({ index, row }) { // 编辑分销
      this.distributionInfo = {
        index: index,
        row: row
      }
      this.$nextTick(() => {
        this.distributionVisible = true;
      })
    },
    editAssemble(index) { // 编辑变参商品组装信息
      this.$refs.addAssembleModal.matchingGoodsStatus = true;
      this.$refs.addAssembleModal.matchingGoodsModal = true;
      this.$refs.addAssembleModal.getNormalGoodsData();
      this.openType = 2; // 变参商品
      this.editAssembleIndex = index; // 记录当前下标
      let value = this.productInfo.productGoodsList[index].productGoodsAssembles;
      if (value) {
        this.$refs.addAssembleModal.matchingGoodsList = value;
        this.$refs.addAssembleModal.openStatus = true;
      }
    },
    addTabData (val) { // 接收子组件传值
      const target = this.productInfo.productGoodsList[this.editAssembleIndex];
      target.productGoodsAssembles = val;
      target.isAssemble = true;
      target.editStatus = true;
      // 同步更新 skuData，确保 productMultiattribute 列表数据一致
      this.skuData = this.deepCopy(this.productInfo.productGoodsList);
    },
    addQuality() { // 新增质检类目
      this.categoryList.push({
        measureName: null,
        measureVal: [
          {
            itemName: null,
            itemValue: null
          }
        ]
      });
    },
    addQualityItem(index) { // 给当前类目添加质检项
      this.categoryList[index].measureVal.push({
        itemName: null,
        itemValue: null
      });
    },
    delQualityItem(index) { // 删除当前类目
      this.categoryList.splice(index, 1);
    },
    delMeasureItem(index, t) { // 删除当前质检项
      this.categoryList[index].measureVal.splice(t, 1);
    },
    // 获取尺码模板的数据
    getTemplateData(ymsProductCategoryId) {
      this.axios.get(api.get_ymsProductSizeTemplate + `${ymsProductCategoryId}`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            this.hideSizeChart = true;
            this.sizeJsonData = data;
            if (this.classifyTalg === 'change') {
              this.handlerTemplate(data);
              if (this.skuPropertyList.length > 0) {
                this.sizeChartdata = [];
                this.skuPropertyList.map((item) => {
                  if (item.name === '尺码') {
                    item.values.map((ele) => {
                      this.sizeChartdata.push(Object.assign({}, { size: ele }, this.templateObj));
                    });
                  }
                });
              }
            }
          } else {
            // 没有绑定尺码模板时，隐藏尺码表
            this.sizeChartdata = [];
            this.hideSizeChart = false;
          }
        }
      });
    },
    // 处理尺码表的单位
    handlerUnit(data, value) {
      let children = [];
      let obj = {};
      if (data.productSizeUnitBos.length > 0) {
        let list = data.productSizeUnitBos;
        list.map((item) => {
          if (item.isDefault === 1) {
            this.templateObj[value + '_defaultUnitName'] = item.name;
            obj = {
              title: item.name,
              key: value + '_defaultValue',
              align: 'center',
              render: (h, params) => {
                return h('InputNumber', {
                  props: {
                    value: params.row[value + '_defaultValue'],
                    min: 0,
                    disabled: (() => {
                      return this.isDisabled;
                    })()
                  },
                  on: {
                    'on-change': val => {
                      this.sizeChartdata[params.index][value + '_defaultValue'] = val;
                    }
                  }
                });
              }
            };
          } else {
            obj = {
              title: item.name,
              key: value + '_value',
              align: 'center',
              render: (h, params) => {
                let num = params.row[value + '_value'];
                let unitValue = params.row[value + '_defaultValue'];
                // 英寸转化厘米
                if (item.name === 'cm') {
                  if (unitValue > 0) {
                    num = unitValue * 2.54;
                    // Math.floor(num * 100) / 100;
                    num = num.toFixed(2);
                  }
                } else {
                  // 厘米转化成英寸
                  if (unitValue > 0) {
                    num = unitValue * 0.393701;
                    // Math.floor(num * 100) / 100;
                    num = num.toFixed(2);
                  }
                }
                this.sizeChartdata[params.index][value + '_value'] = Number(num) === 0
                  ? null
                  : Number(num);
                return h('span', num);
              }
            };
          }
          children.push(obj);
        });
        return children;
      }
    },
    // 处理尺码表的数据
    handlerTemplate(data, ymsProductCategoryId) {
      // 查看的时候
      this.sizeChartColumns = [];
      const fixColumn = [
        {
          title: 'UK Size',
          key: 'ukSize',
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                value: isNaN(Number(params.row.ukSize)) ? 0 : params.row.ukSize
              },
              style: {
                width: '70px'
              },
              on: {
                'on-change'(e) {
                  if (!isNaN(Number(e.target.value))) {
                    this.sizeChartdata[params.index]['ukSize'] = e.target.value;
                  } else {
                    this.sizeChartdata[params.index]['ukSize'] = 0;
                  }
                }
              }
            });
          }
        }, {
          title: 'EU Size',
          key: 'euSize',
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                value: isNaN(Number(params.row.euSize)) ? 0 : params.row.euSize
              },
              style: {
                width: '70px'
              },
              on: {
                'on-change'(e) {
                  if (!isNaN(Number(e.target.value))) {
                    this.sizeChartdata[params.index]['euSize'] = e.target.value;
                  } else {
                    this.sizeChartdata[params.index]['euSize'] = 0;
                  }
                }
              }
            });
          }
        }, {
          title: 'US Size',
          key: 'usSize',
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                value: isNaN(Number(params.row.usSize)) ? 0 : params.row.usSize
              },
              style: {
                width: '70px'
              },
              on: {
                'on-change'(e) {
                  if (!isNaN(Number(e.target.value))) {
                    this.sizeChartdata[params.index]['usSize'] = e.target.value;
                  } else {
                    this.sizeChartdata[params.index]['usSize'] = 0;
                  }
                }
              }
            });
          }
        }];

      if (this.classifyTalg === 'look' || this.classifyTalg === 'edit') {
        // 判断当前的单位
        this.axios.get(api.get_ymsProductSizeTemplate + `${ymsProductCategoryId}`).then(response => {
          if (response.data.code === 0) {
            let unitData = response.data.datas;
            if (data) {
              let size = {
                title: 'Tag Size',
                key: 'sizeCode',
                align: 'center',
                render: (h, params) => {
                  return h('Input', {
                    props: {
                      size: 'small',
                      value: params.row.sizeCode
                    },
                    style: {
                      width: '70px'
                    }
                  });
                }
              };
              // 部位
              data.forEach((item) => {
                let obj = {};
                this.sizeChartColumns = [];
                item.sizeDetailBos.forEach((ele, index) => {
                  item['partsName_' + index] = ele.partsName;
                  item['unitName_' + index] = ele.unitName;
                  item['unitValue_' + index] = ele.unitValue;
                  this.editObj['partsName_' + index] = ele.partsName;
                  this.editObj['unitName_' + index] = ele.unitName;
                  this.editObj['unitValue_' + index] = null;
                  if (unitData.productSizeUnitBos.length > 0) {
                    let list = unitData.productSizeUnitBos;
                    let objs = {};
                    let children = [];
                    list.forEach((item) => {
                      if (item.isDefault === 1) {
                        objs = {
                          title: item.name,
                          key: 'unitValue_' + index,
                          align: 'center',
                          render: (h, params) => {
                            let unitValue = Number(params.row['unitValue_' + index]);
                            return h('InputNumber', {
                              props: {
                                value: unitValue,
                                min: 0,
                                disabled: (() => {
                                  return this.isDisabled;
                                })()
                              },
                              on: {
                                'on-change': val => {
                                  this.sizeChartdata[params.index]['unitValue_' + index] = val;
                                }
                              }
                            });
                          }
                        };
                      } else {
                        objs = {
                          title: item.name,
                          key: 'unitValue_' + index,
                          align: 'center',
                          render: (h, params) => {
                            // 英寸转化厘米
                            let unitValue = Number(params.row['unitValue_' + index]);
                            let num = '';
                            if (item.name === 'cm') {
                              if (unitValue > 0) {
                                num = unitValue * 2.54;
                                // Math.floor(num * 100) / 100;
                                num = num.toFixed(2);
                              }
                            } else {
                              // 厘米转化成英寸
                              if (unitValue > 0) {
                                num = unitValue * 0.393701;
                                // Math.floor(num * 100) / 100;
                                num = num.toFixed(2);
                              }
                            }
                            return h('span', num);
                          }
                        };
                      }
                      children.push(objs);
                      obj = {
                        title: ele.partsName,
                        align: 'center',
                        maxWidth: 220,
                        children: children
                      };
                    });
                  }
                  this.sizeChartColumns.push(obj);
                });
              });
              this.sizeChartColumns.unshift(size, ...fixColumn);
              this.sizeChartdata = data;
            }
          }
        });
      } else {
        // 切换选取其他云卖分类的时候
        if (data) {
          let size = {
            title: 'Tag Size',
            key: 'size',
            align: 'center',
            render: (h, params) => {
              return h('Input', {
                props: {
                  value: params.row.size,
                  disabled: true
                },
                style: {
                  width: '100px'
                }
              });
            }
          };
          // 部位
          let place = {};
          if (data.productSizePartsBos.length > 0) {
            data.productSizePartsBos.map((item, index) => {
              this.templateObj[item.ymsProductSizePartsId + '_partName'] = item.name;
              this.templateObj[item.ymsProductSizePartsId + '_defaultValue'] = null;
              this.templateObj[item.ymsProductSizePartsId + '_value'] = null;
              place = {
                title: item.name,
                align: 'center',
                maxWidth: 220,
                children: this.handlerUnit(data, item.ymsProductSizePartsId)
              };
              this.sizeChartColumns.push(place);
            });
          }
          this.sizeChartColumns.unshift(size, ...fixColumn);
        }
      }
    },
    // 处理添加尺码属性的数据
    handlerSizeData(data) {
      if (this.classifyTalg === 'edit') {
        if (data) {
          if (data.name === '尺码') {
            data.values.map((ele) => {
              this.sizeChartdata.push(Object.assign({}, this.editObj, { sizeCode: ele, ukSize: '', euSize: '', usSize: '' }));
            });
          }
          this.sizeChartdata = this.uniqueFunc(this.sizeChartdata, 'sizeCode');
        }
      } else if (this.classifyTalg === 'change') {
        this.sizeChartdata = [];
        if (data) {
          if (data.name === '尺码') {
            data.values.map((ele) => {
              this.sizeChartdata.push(Object.assign({}, { size: ele }, this.templateObj));
            });
          }
        }
      }
    },
    // 咨询是否同步数据
    synchronousRemind(resolve) {
      if (!this.permission.synchronous) {
        this.turnBack();
        this.$emit('update:editProductModal', false);
        this.$parent.$parent.pageParamsStatus = true;
        return
      }
      this.$Modal.confirm({
        width: 500,
        title: '商品信息变更',
        content: `是否自动同步商品信息至Listing？
        <div style="margin-top:10px; color:#f20;">
          注意：该操作会同步覆盖Listing中的商品基础资料，所有基础信息，多属性信息，属性信息，以ERP系统为主。
        </div>`,
        onOk: () => {
          this.turnBack();
          this.turnUpdate();
          this.$parent.$parent.pageParamsStatus = true;
          // 同步商品信息
          this.axios.post(api.synProductInfoToListing, {
            productInfoIds: [resolve.productId],
            type: [0]
          }).then(res => {
            // if (res && res.data && res.data.code == 0 && res.data.datas) {
            if (res && res.data && res.data.code == 0) {
              // const failTotal = res.data.datas.addFailNum + res.data.datas.updateFailNum;
              // if (failTotal == 0) {
              //   this.$Message.success('同步数据成功！')
              // } else {
              //   this.$Message.error('同步商品信息失败')
              // }
              this.$Message.success('同步商品信息操作完成');
            } else {
              this.$Message.error('同步商品信息操作失败')
            }
          }).catch(() => {
            this.$Message.error('同步商品信息操作失败')
          })
        },
        onCancel: () => {
          this.$parent.$parent.pageParamsStatus = true;
          this.turnBack();
          this.turnUpdate();
        }
      })
    },
    // 编辑多属性（委托给子组件）
    editAttributes(info) {
      // 确保多属性 Tab 已渲染（pageTagView['multiattribute'] 为 true）
      if (!this.pageTagView['multiattribute']) {
        this.pageEditTag = 'multiattribute';
      }
      this.$nextTick(() => {
        if (this.$refs.productMultiattributeRef) {
          this.$refs.productMultiattributeRef.editAttributes(info);
        }
      });
    },
    // 绑定尺码组弹窗
    bindSizeGroupNo() {
      this.$Modal.confirm({
        title: '操作提示',
        content: '请先绑定商品尺码组',
        onOk: () => {
          this.bindSizeModuleData = {
            sizeList: this.$common.copy(this.sizeList),
            skuData: this.$common.copy(this.skuData),
            productInfo: this.$common.copy(this.productInfo)
          }
          this.$nextTick(() => {
            setTimeout(() => {
              this.bindSizeGroupVisible = true;
            }, 310)
          })
        },
        onCancel: () => {
          this.$nextTick(() => {
            setTimeout(() => {
              this.editAttributes({});
            }, 310)
          })
        }
      });
    },
    // 获取颜色
    getColorList() {
      return new Promise((resolve) => {
        this.axios.get(api.getColorList, { hiddenError: true }).then(res => {
          if (res.data.code === 0) {
            this.colorList = res.data.datas;
          }
        }).finally(() => {
          resolve({ state: 'finally' });
        })
      })
    },
    // 获取尺码
    getSizeList() {
      return new Promise((resolve, reject) => {
        let productCategoryId = this.treeSelectCategoryValue;
        let productType = null;
        let sizeType = null;
        this.productCategoryListData.forEach(k => {
          if (k.productCategoryId == productCategoryId) {
            sizeType = k.sizeType
            productType = k.productType
          } else if (k.children) {
            k.children.forEach(j => {
              if (j.productCategoryId == productCategoryId) {
                sizeType = j.sizeType
                productType = j.productType
              }
            })
          }
        })
        this.sizeTypeFar = sizeType;
        this.productTypeFar = productType;
        // 判断商品类型： 服饰 家居 饰品
        if ((productType == 0 || productType == 2) && (sizeType || sizeType == 0)) {
          this.columnSizeOrModel = 'Size'
        } else {
          this.columnSizeOrModel = 'Model'
        }
        if (sizeType || sizeType === 0) {
          // this.axios.get(api.getSizeList, { params: { sizeTypeId: sizeType } }).then(res => {
          this.axios.get(api.getSizeHistory, { params: { erpProductId: this.productId } }).then(res => {
            if (res.data.code === 0) {
              let list = [];
              let datas = res.data.datas;
              for (let i = 0; i < datas.length; i++) {
                let temp = {
                  ...datas[i],
                  value: 'arr' + (i + 1),
                  label: '尺码组' + (i + 1),
                  children: datas[i].sizeList
                };
                list.push(temp);
              }
              for (let i in list) {
                for (let j in list[i].children) {
                  list[i].children[j].value = list[i].children[j].size;
                  list[i].children[j].label = list[i].children[j].size
                }
              }
              this.sizeList = list || []
            }
          });
        } else {
          this.sizeList = []
        }
        resolve();
      })
    },
    openSizeChart(type) {
      // if (!type) return;
      this.planType = type;
      const obj = { 1: 'chartModalVisible', 2: 'childVisible', 3: 'childVisible', 4: 'chartModalVisible' };
      if ([1, '1'].includes(type)) {
        this.getProductDetail();
      }
      this.$nextTick(() => {
        this[obj[type]] = true;
      })
    },
    getProductDetail() {
      return new Promise((resolve, reject) => {
        this.axios.get(api.queryLaPaProductGoodsInfo, {
          params: { productId: this.productInfo.productId }
        }).then((res) => {
          if (res.data.code === 0) {
            // 商品多属性(用于尺码图的左侧属性)
            this.$set(this.commodiAttr, 'laPaProductVariQuotationList', res.data.datas.laPaProductVariQuotationList || []);
            resolve(res.data.datas.attributeValueVOList || []);
          }
        }).catch(err => {
          reject(err);
        });
      })
    },
    // 禁用 所属分类下拉树
    disabledTreeItem() {
      return new Promise((resolve) => {
        const handTreeData = (arr, parent) => {
          if (!this.$common.isEmpty(parent) && parent.productCategoryId !== 'productCategoryId') {
            this.$set(parent, 'isDisabled', !parent.productChildType.includes(this.productTypeFar));
          }
          arr.forEach(item => {
            if (!this.$common.isEmpty(item.children)) {
              this.$set(item, 'productChildType', this.getChildAllType(item.children, item.productType));
              handTreeData(item.children, item);
            } else {
              if (item.productCategoryId !== 'productCategoryId') {
                this.$set(item, 'isDisabled', item.productType !== this.productTypeFar);
              }
            }
          });
          return arr;
        }
        this.productCategoryTree = handTreeData(this.$common.copy(this.productCategoryTree));
        // let tree = this.productCategoryTree[0].children;
        // tree.forEach(k => {
        //   if (k.children) {
        //     k.productType = k.children[0].productType
        //   } else {
        //     k.productType = null
        //   }
        //   if (k.productType !== this.productTypeFar) {
        //     this.$set(k, 'isDisabled', true)
        //   }
        //   if ((k.productType === '1' && this.productTypeFar === null) || (k.productType === null && this.productTypeFar === '1')) {
        //     this.$set(k, 'isDisabled', false)
        //   }
        // })
        resolve()
      })
    },
    // 获取子级所有 productType (包含自身)
    getChildAllType(arr, productType) {
      let list = [productType];
      arr.forEach(item => {
        list.push(item.productType);
        if (!this.$common.isEmpty(item.children)) {
          list = [...list, ...this.getChildAllType(item.children, item.productType)];
        }
      });
      return this.$common.arrRemoveRepeat(list).filter(f => !this.$common.isEmpty(f));
    },
    // 更新图片
    getSizePicture(data) {
      let list = [];
      let selfPic = [];
      const commonImages = this.productInfo.multiLangImageList.find(item => {
        return item.language === 'common';
      }) || {};
      const newImages = this.multiLangImageData.find(item => {
        return item.language === 'common';
      }) || {};
      const imgPathList = [...(commonImages.images || []), ...(this.productInfo.productImageTypeList || [])].filter(item => {
        return [2, 3, 4, '2', '3', '4'].includes(item.imageType);
      }).map(m => m.path);
      const getImages = (newImages.images || []).filter(item => {
        return !imgPathList.includes(item.path);
      });
      (data || []).forEach(item => {
        list.push(item.pictureUrl);
        if (![0, 1, '0', '1'].includes(item.pictureType)) {
          selfPic.push({
            path: item.pictureUrl,
            imageType: item.pictureType
          });
        }
      });
      // 使用 map 生成新数组，确保 Vue 能追踪变化；使用 selfPic 中已带 imageType 的图片替换纯路径列表
      const selfPicPaths = selfPic.map(p => p.path);
      const normalPics = list
        .filter(p => !selfPicPaths.includes(p))
        .map(p => ({ path: p, imageType: null }));
      const newSizePics = selfPic.concat(normalPics);
      this.multiLangImageData = this.multiLangImageData.map(item => {
        if (item.language === 'common') {
          return { ...item, images: getImages.concat(newSizePics) };
        }
        return { ...item };
      });
    },
    loadPicture() {
      // productInfo.productImages 为分组结构 [{language, images:[{path}]}]
      (this.productInfo.productImages || []).forEach(group => {
        (group.images || []).forEach(img => {
          let image = new Image();
          image.src = this.filenodeViewTargetUrl + img.path;
        });
      });
    },
    checkOldData() {
      /*
        1、当 productGoodsList 数组下的所有 productGoodsSpecifications 为空时即为旧数据
        2、当 productGoodsList 数组下的 productGoodsSpecifications 有非空存在时，并且数组 productGoodsSpecifications 中的 typeValueId 存在空值时即为旧数据
      */
      const getOldItem = this.firstProductInfo.productGoodsList.filter(f => {
        if (!this.$common.isEmpty(f.productGoodsSpecifications)) {
          const findItem = f.productGoodsSpecifications.find(item => {
            return this.$common.isEmpty(item.typeValueId);
          })
          return !this.$common.isEmpty(findItem);
        }
        return true;
      })
      this.isOldData = !this.$common.isEmpty(getOldItem);
    },
    getChildType(type) {
      this.type = type;
    },
    tableEditcontent(html) {
      this.$refs.descdomeue.tableEditcontent(html)
    },
    // 分销变更
    distributionConfirm(option) {
      // console.log(option,'option 分销变更')
      this.$set(this.productInfo.productGoodsList[option.index], 'distributionPriceType', option.distributionPriceType);
      this.$set(this.productInfo.productGoodsList[option.index], 'distributionPriceValue', option.distributionPriceValue);
      // // 同步到 skuData（通过更新 productGoodsList 并重新赋值触发 watch → emit，或直接 emit update:skuData）
      // const newSkuData = this.deepCopy(this.skuData);
      // if (newSkuData[option.index]) {
      //   newSkuData[option.index].distributionPriceType = option.distributionPriceType;
      //   newSkuData[option.index].distributionPriceValue = option.distributionPriceValue;
      // }
      // this.$emit('update:skuData', newSkuData);
      // 同步更新 skuData，确保 productMultiattribute 列表数据一致
      this.skuData = this.deepCopy(this.productInfo.productGoodsList);
    },
    // 验证质检比例
    validateCheckRate(rule, value, callback) {
      if (![1, '1'].includes(this.productInfo.checkType)) {
        return callback();
      }
      this.$nextTick(() => {
        let newVal = this.productInfo.checkRate;
        if (this.$common.isEmpty(newVal, true)) {
          return callback(new Error('请输入质检比例'));
        }
        this.$common.validatorMaxNumber(rule, newVal, callback);
      })
    },
    // 验证应检最少数量
    validateMinCheckNum (rule, value, callback) {
      if ([0, '0'].includes(this.productInfo.checkType)) {
        return callback();
      }
      this.$nextTick(() => {
        let newVal = this.productInfo.minCheckNum;
        this.$common.validatorMaxNumber(rule, newVal, callback);
      })
    },
    // 验证报关中文
    hsNameMaxVerify(rule, value, callback) {
      const newVal = this.$common.isEmpty(value) ? '' : value.trim();
      const regex = this.$regular.hasChinese;
      if (!this.$common.isEmpty(newVal) && !regex.test(newVal)) {
        return callback(new Error('必须包含中文'));
      }
      this.$common.strMaxVerify(rule, value, callback);
    },
    // 验证报关英文
    enNameMaxVerify(rule, value, callback) {
      const newVal = this.$common.isEmpty(value) ? '' : value.trim();
      // eslint-disable-next-line no-useless-escape
      const regex = this.$regular.hasEnglish;
      if (!this.$common.isEmpty(newVal) && !regex.test(newVal)) {
        return callback(new Error('必须包含英文'));
      }
      this.$common.strMaxVerify(rule, value, callback);
    },
    hsCodeVerify(rule, value, callback) {
      const newVal = this.$common.isEmpty(value) ? '' : value.trim();
      const regex = this.$regular.AllNumber;
      if (!this.$common.isEmpty(newVal) && !regex.test(newVal)) {
        return callback(new Error('请输入数字'));
      }
      this.$common.strMaxVerify(rule, value, callback);
    },
    // 向对应语言的复杂描述插入尺码模板
    insetDescription(data) {
      if (this.$common.isEmpty(this.descriptionBOJson[data.tabName])) return;
      let divDemo = document.createElement('div');
      divDemo.id = `${data.tableId}-content`;
      divDemo.style.position = 'absolute';
      divDemo.style.zIndex = '-10';
      divDemo.style.width = '100vw';
      divDemo.style.height = '100vh';
      divDemo.style.top = '100vh';
      divDemo.innerHTML = this.descriptionBOJson[data.tabName].description;
      document.body.appendChild(divDemo);
      this.$nextTick(() => {
        const tableHtml = divDemo.querySelector(`#${data.tableId}`);
        if (tableHtml) {
          tableHtml.remove();
          this.descriptionBOJson[data.tabName].description = divDemo.innerHTML + data.html;
        } else {
          this.descriptionBOJson[data.tabName].description += data.html;
        }
        divDemo.remove();
        if (this.langActiveTab == data.tabName && this.descActiveTab == 'description') {
          // 插入描述
          this.editor.setContent(this.descriptionBOJson[this.langActiveTab].description);
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.product-upload-list {
  width: 200px;
  height: 200px;
}

.custom-tag-input {
  line-height: normal;
  border: 1px solid #dddee1;
  border-radius: 4px;
  padding: 0 0 0 0;
}

.product-upload-list-cover i {
  margin: 0 6px;
}

.classify_style {
  :deep(.ivu-form-item-label) {
    &:before {
      content: "*";
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      font-family: SimSun;
      font-size: 14px;
      color: #ed4014;
    }
  }
}

.box100 {
  width: 100px;
  height: 100px;
}

.box200 {
  width: 200px;
  height: 200px;
}

.box500 {
  width: 500px;
  height: 500px;
}

.attrForm {
  :deep(.ivu-form-item-label) {
    padding-left: 25px;
  }
}
.gpsr-tips-icon{
  .ivu-icon {
    font-size: 20px;
    color: #f20;
  }
}
.inputValue {
  display: inline-block;
  width: 160px;
}

.formItemLeft {
  width: 480px;

  :deep(.ivu-form-item-label) {
    padding-left: 10px;
  }
}

.bgContent {
  :deep(.ivu-form-item-label) {
    padding-left: 10px;
  }
}

.bottomBtn {
  display: flex;
  padding: 10px;
  flex-direction: row-reverse;
}

.tabs-textmaterial {
  position: relative;

  :deep(.tabs-btnpos) {
    position: absolute;
    top: 10px;
    right: 20px;
  }
}

.editPage {
  position: absolute;
  width: 100%;
  height: calc(100vh - 95px);
  top: 0;
  left: 0;
  background: #fff;
  overflow: hidden;
  z-index: 9;

  :deep(.edit-page-form) {
    height: calc(100% - 42px);
    overflow: auto;
    &.ivu-form {
      .ivu-form-item-label {
        padding: 10px 5px 10px 0;
      }
    }
  }

  :deep(.ivu-select) {
    text-align: left;
  }
  :deep(.accessory-style) {
    .upload-contain{
      display: inline-block;
      width: 85px;
      vertical-align: top;
    }
    .uploaded-file-list{
      display: inline-block;
      max-width: calc(100% - 85px);
      vertical-align: top;
      .uploaded-file-item{
        display: inline-block;
        width: auto;
        &:hover{
          background: none;
          color: #2d8cf0;
        }
        .file-title{
          width: auto;
          max-width: initial;
          vertical-align: middle;
          text-decoration: underline;
          color: #2d8cf0;
        }
        .remove-uploaded-file{
          display: inline-block;
          vertical-align: middle;
          i {
            color: #f20;
          }
        }
      }
    }
  }
}

.topBtn {
  position: sticky;
  display: flex;
  justify-content: space-between;
  top: 0;
  width: 100%;
  text-align: right;
  background: #fff;
  z-index: 9999;
  box-shadow: 0px 1px 5px #bbb;

  .top-tags {
    height: 42px;
  }

  .head-tabs {
    height: 100%;

    .ivu-radio-group {
      height: 100%;

      .ivu-radio-wrapper {
        height: 42px;
        line-height: 42px;
        border: none;

        &.ivu-radio-wrapper-checked {
          color: #fff;
          background: #2d8cf0;
          border-radius: 0;
        }

        &:before {
          content: '';
          display: none;
        }
      }
    }
  }

  .top-buttons {
    margin: 5px;
    padding: 0 10px;
  }
}

.form-item-flex-wrap {
  display: flex;
  flex-flow: row wrap;

  .ivu-form-item {
    width: 33.33%;
    min-width: 300px;
  }
}

.display-flex {
  display: flex;

  .flex-30 {
    flex: 30;
  }

  .flex-70 {
    flex: 70;
  }
}

.products-content {
  &.purchase-content {
    display: flex;
    flex-flow: wrap;

    :deep(.ivu-form-item) {
      padding-left: 15px;
      width: 25%;
      min-width: 300px;
      max-width: 450px;
    }
  }
}
.tag-comtent-item{
  height: 100%;
  overflow: auto;
}
.washable-max-pic-view{
  max-width: 500px;
  max-height: 400px;
}
.washable-label-view {
  display: flex;
  align-items: center;
  min-height: 32px;
  line-height: 0;
  .washable-pic-view{
    max-width: 60px;
    max-height: 40px;
    cursor: pointer;
  }
  .washable-pdf-view{
    line-height: 1.2em;
    span{
      cursor: pointer;
      color: #57a3f3;
      text-decoration: underline;
      text-underline-offset: 3px;
    }
  }
}
</style>
<style lang="less">
.custom-tag-input .ivu-input {
  border: none;
  height: 30px;
}

.custom-tag-input .ivu-input:focus {
  border-color: red;
  border: none;
  box-shadow: none;
}

.custom-tag-input .ivu-input:hover {
  border-color: red;
  border: none;
}

.custom-tag-input .ivu-tag {
  word-break: break-all;
  height: auto;
}

.productsCont {
  background-color: #fff;
  border: 1px solid #d7dde4;

  .sizeChartTable {

    .ivu-table td,
    .ivu-table th {
      border-bottom: 1px solid #e8eaec;
      border-left: 1px solid #e8eaec;
    }

    .ivu-table td:last-child,
    .ivu-table th:last-child {
      border-right: 1px solid #e8eaec;
    }
  }
}

.products-content {
  .important-attribute {
    .ivu-form-item-label {
      color: #f20;
      font-weight: bold;
    }
  }
}

.click-text-underline {
  display: inline-block;
  position: relative;
  padding: 0px 5px;
  cursor: pointer;
  color: #57a3f3;
  text-decoration: underline;
  text-underline-offset: 3px;

  &.click-text-disabled {
    color: #f3f3f3;
    cursor: no-drop;
  }
}

.text-translate-5 {
  transform: translate(0, -5px);
}

.washed-operate {
  display: flex;

  .washed-image-content {
    position: relative;
    width: 60px;
    height: 60px;
    box-shadow: 0 0 5px #ccc;
    border-radius: 5px;

    img {
      cursor: pointer;
      height: 100%;
      width: 100%;
    }
  }

  .washed-image-preview-content {
    position: relative;

    img {
      max-width: 600px;
      max-height: 600px;
      min-width: 200px;
    }
  }
}
</style>
